<template>
  <div class="common-layout">
    <el-container>
      <el-header>
        <div style="display: flex;flex-direction: row;justify-content:flex-start;">
          <el-button type="primary" @click="add" style=" position: relative ;left: 0px">添加</el-button>

          <el-input v-model.trim="search" style="width: 250px; position: relative ;left: 20px" maxlength="50" show-word-limit placeholder="输入使用单位名称" clearable>

          </el-input>
          <el-input v-model.trim="superviseCode" style="width: 250px ; position: relative ;left: 20px" maxlength="50" show-word-limit placeholder="输入监察识别码" clearable>

          </el-input>
          <el-button type="primary" style=" position: relative ;left: 20px" @click="qSearch()">查询</el-button>
          <el-button type="primary" style=" position: relative ;left: 20px" @click="refresh()">刷新</el-button>
          <el-upload action="#" :show-file-list="false" :before-upload="importBefore" accept=".xls,.xlsx"
                     style=" position: relative ;left: 30px"
          >
            <el-button type="primary">表格导入</el-button>
          </el-upload>
          <el-button type="primary" style=" position: relative ;left: 40px" @click="exportDate()">导出数据</el-button>
          <!--          <el-button type="primary" style=" position: relative ;left: 0px" @click="importBefore()">导入数据</el-button>-->
          <!--      success  </div>-->
        </div>
      </el-header>
      <el-main>
        <el-table
            :data="tableData"
            style="width: 100%;height:50vh"
            border
            :row-class-name="tableRowClassName"
        >
          <el-table-column label="操作" min-width="150" max-width="200">
            <template #default="scope">
              <el-button type="primary" size="small" @click="update( scope.row)">修改</el-button>
              <el-button type="primary" size="small" style="margin-left: 3px;" @click="deleteOne( scope.row.liftId)">
                删除
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="unit" min-width="150" max-width="200" label="使用单位名称"></el-table-column>
          <!--            <el-table-column prop="specialType" width="120" sortable  label="特种设备类型">-->
          <!--                <template v-slot="scope">-->
          <!--                    <span v-show="scope.row.specialType!==null">{{scope.row.specialType===1?'电梯':'起重器'    }}</span>-->
          <!--                </template>-->
          <!--            </el-table-column>-->
<!--          <el-table-column prop="unitCode" min-width="150" max-width="200" label="使用单位代码"></el-table-column>-->
          <el-table-column prop="superviseCode" min-width="150" max-width="200" label="监察识别码"></el-table-column>
          <el-table-column prop="loginNum" min-width="150" max-width="200" label="使用登记证编号"></el-table-column>
          <el-table-column prop="detailArea" min-width="150" max-width="200" label="使用设备地点"></el-table-column>
          <el-table-column prop="unitNum" min-width="150" max-width="200" label="单位内编码"></el-table-column>
          <el-table-column prop="liftType" min-width="150" max-width="200" label="设备品种"></el-table-column>
          <el-table-column prop="liftModel" min-width="150" max-width="200" label="产品型号"></el-table-column>
          <el-table-column prop="liftNum" min-width="150" max-width="200" label="产品编号"></el-table-column>
          <el-table-column prop="createUnit" min-width="150" max-width="200" label="制造单位"></el-table-column>

        </el-table>
      </el-main>
      <el-footer>
        <div class="demonstration" style="margin: 10px 0">
          <el-pagination v-model:currentPage="currentPage"
                         v-model:page-size="pageSize"
                         :page-sizes="[20, 40,60]"
                         :small="small"
                         :background="background"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total"
                         :prev="prev"
                         :pager="pager"
                         :next="next"
                         :jumper="jumper"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"></el-pagination>
        </div>
      </el-footer>
    </el-container>
    <!--    style="margin-top: 30px"-->
    <el-dialog v-model="dialogFormVisible" title="添加设备" :lock-scroll="false"
               width="80%">
      <!--        :fullscreen="true" draggable   style="width: 320px"-->
      <el-row>
        <el-col :span="24">
          <el-form :model="form" :inline="true" ref="form" :rules="rules" status-icon label-width="140px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="设备种类" prop="specialType" style="width: 440px">
                  <el-select style="width: 300px" v-model="form.specialType"
                             @change="getEqpType(form.specialType)"
                             placeholder="请选择设备种类" clearable>
                    <el-option label="电梯" :value="1"></el-option>
                    <el-option label="起重器" :value="2"></el-option>

                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="使用单位名称" prop="unit" style="width: 440px">
<!--                  <el-input v-model.trim="form.unit"-->
<!--                            style="width: 300px" placeholder="请输入使用单位名称"-->
<!--                            clearable autocomplete="off" show-word-limit-->
<!--                            maxlength="50" required></el-input>-->
                  <!-- 张 5.13   trigger-on-focus=true获取焦点即列出输入建议 -->
                  <el-autocomplete
                      class="inline-input"
                      v-model="form.unit"
                      clearable
                      :fetch-suggestions="querySearch"
                      value-key="unit"
                      placeholder="请输入使用单位名称"
                      :trigger-on-focus="false"
                      @select="handleSelect"
                      style="width: 80%"
                  ></el-autocomplete>
                  <el-button  class="iconfont icon-tianjia" size="medium" style="margin-left: 1px;"
                              @click="addUnit(1)" >
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <div v-show="form.specialType===1">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="监察识别码" style="width: 440px" prop="superviseCode">
                    <el-input v-model.trim="form.superviseCode"
                              style="width: 300px" placeholder="请输入监察识别码"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="额定载重量" prop="maxWeight" style="width: 440px">
                    <el-input-number style="width: 300px" v-model="form.maxWeight" :precision="1"
                                     :step="1" :min="0"
                                     :max="10000"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="设备使用地点" style="width: 440px">
                    <el-select style="width: 300px" v-model="areaParentIdOne" placeholder="请选择"
                               @change="queryAreaList2"
                               clearable>
                      <el-option v-for="(item, key) in areaList" v-bind:key="item"
                                 :label="item.areaName "
                                 :value="key"></el-option>
                    </el-select>
                    <el-select style="width: 300px" v-model="areaParentIdTwo" placeholder="请选择"
                               @change="queryAreaList3"
                               clearable>
                      <el-option v-for="(item, key) in areaList2" v-bind:key="item"
                                 :label="item.areaName "
                                 :value="key"></el-option>
                    </el-select>
                    <el-select style="width: 300px" v-model="areaParentIdThree" placeholder="请选择"
                               @change="queryAreaList4"
                               clearable>
                      <el-option v-for="(item, key) in areaList3" v-bind:key="item"
                                 :label="item.areaName "
                                 :value="key"></el-option>
                    </el-select>
                    <el-input v-model.trim="form.detailArea" placeholder="请输入具体地址"
                              style="width: 300px;" clearable autocomplete="off" show-word-limit
                              maxlength="500" required></el-input>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <div>
                    <el-form-item label="额定压力" class="rightStyle">
                      <el-input type="number" v-model="form.pressure" placeholder="请输入额定压力"
                                style="width: 300px;" :min="0" clearable autocomplete="off"
                                show-word-limit
                                maxlength="50" required></el-input>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="额定速度" prop="speed" class="rightStyle">
                      <el-input-number style="width: 300px" v-model="form.speed" :precision="2"
                                       :step="0.1" :min="0"
                                       :max="100"></el-input-number>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="额定速度（上行）" style="width: 440px" class="rightStyle">
                      <el-input-number style="width: 300px" v-model="form.speedUp" :precision="2"
                                       :step="0.1" :min="0"
                                       :max="100"></el-input-number>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="设备所在区域" style="width: 440px" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="form.lifeArea" placeholder="请输入设备所在区域"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="楼盘名称" class="rightStyle">
                    <el-input v-model.trim="form.propertyName" placeholder="请输入楼盘名称"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="分支机构名称" style="width: 440px" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="form.branchName" placeholder="请输入分支机构名称"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="驱动主机型号" class="rightStyle">
                    <el-input v-model.trim="form.driveModel" placeholder="请输入驱动主机型号" :min="0"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="驱动主机编号" style="width: 440px" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="form.driveCode" placeholder="请输入驱动主机编号"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="控制柜型号" class="rightStyle">
                    <el-input v-model.trim="form.controlBoxModel" placeholder="请输入控制柜型号" :min="0"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="控制柜编号" style="width: 440px" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="form.controlBoxCode"
                              placeholder="请输入控制柜编号"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="轿厢限速器型号" class="rightStyle">
                    <el-input v-model.trim="form.carModel" placeholder="请输入轿厢限速器型号"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="轿厢限速器编号" style="width: 440px" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="form.carCode" placeholder="请输入轿厢限速器编号"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="对重限速器型号" class="rightStyle">
                    <el-input v-model.trim="form.counterweightModel" placeholder="请输入对重限速器型号"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="对重限速器编号" style="width: 440px" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="form.counterweightModelCode"
                              placeholder="请输入对重限速器编号"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="使用单位地址" class="rightStyle">
                    <el-input v-model.trim="form.unitArea" placeholder="请输入使用单位地址"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="分支机构地址" style="width: 440px" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="form.branchArea" placeholder="请输入分支机构地址"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="楼盘地址" class="rightStyle">
                    <el-input v-model.trim="form.propertyArea" placeholder="请输入楼盘地址"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div>
                    <el-form-item label="制造时间日期格式" prop="createDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="form.createDateType"
                                 @change="getDateType(form.createDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="制造时间" class="rightStyle" prop="createDate">
                      <el-date-picker
                              v-model="form.createDate"
                              type="date"
                              placeholder="制造时间"
                              v-if="form.createDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.createDate"
                              type="date"
                              placeholder="制造时间"
                              v-if="form.createDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.createDate"
                              type="date"
                              placeholder="制造时间"
                              v-if="form.createDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>

                    </el-form-item>
                  </div>

                </el-col>
                <el-col :span="12">
                  <div>
                    <el-form-item label="上次检验日期格式" prop="preDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="form.preDateType"
                                 @change="getDateType(form.preDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="上次检验日期" class="rightStyle">
                      <el-date-picker
                              v-model="form.preDate"
                              type="date"
                              placeholder="上次检验日期"
                              v-if="form.preDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.preDate"
                              type="date"
                              placeholder="上次检验日期"
                              v-if="form.preDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.preDate"
                              type="date"
                              placeholder="上次检验日期"
                              v-if="form.preDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </div>

                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="额定速度（下行）" style="width: 440px" class="rightStyle">
                    <el-input-number style="width: 300px" v-model="form.speedDown" :precision="2"
                                     :step="0.1" :min="0"
                                     :max="100"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="油缸数量" class="rightStyle">
                    <el-input type="number" v-model="form.hcNum" placeholder="请输入油缸数量" :min="0"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="满载压力" class="rightStyle">
                    <el-input type="number" v-model="form.maxPressure" :min="0"
                              placeholder="请输入满载压力"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="使用单位代码" prop="unitCode">
                    <el-input v-model.trim="form.unitCode" placeholder="请输入使用单位代码"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="层" class="rightStyle" prop="storey">
                    <el-input type="number" :min="0" v-model="form.storey" placeholder="请输入层数"
                              clearable autocomplete="off" show-word-limit style="width: 300px"
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="使用登记证编号" prop="loginNum">
                    <el-input v-model.trim="form.loginNum" class="rightStyle" placeholder="请输入使用登记证编号"
                              clearable autocomplete="off" show-word-limit
                              style="width: 300px"
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="站" class="rightStyle" prop="stand">
                    <el-input type="number" v-model="form.stand" placeholder="请输入站数"
                              :min="0" clearable autocomplete="off" show-word-limit
                              style="width: 300px"
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="单位内编码" class="rightStyle" prop="unitNum">
                    <el-input v-model.trim="form.unitNum" placeholder="请输入单位内编码"
                              clearable autocomplete="off" show-word-limit
                              style="width: 300px"
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="门" class="rightStyle" prop="door">
                    <el-input type="number" v-model="form.door" :min="0" placeholder="请输入门数"
                              clearable autocomplete="off" show-word-limit style="width: 300px"
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="设备注册代码" class="rightStyle" prop="lifeRegistCode">
                    <el-input style="width: 300px" v-model.trim="form.lifeRegistCode"
                              placeholder="请输入设备注册代码"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>

                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="控制方式" class="rightStyle" prop="controller">
                    <el-select style="width: 300px" v-model="form.controller" placeholder="请选择控制方式"
                               clearable>
                      <el-option label="集选" value="集选"></el-option>
                      <el-option label="并联" value="并联"></el-option>
                      <el-option label="群控" value="群控"></el-option>
                      <el-option label="按钮" value="按钮"></el-option>
                      <el-option label="信号控制" value="信号控制"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="设备代码" class="rightStyle" prop="lifeCode">
                    <el-input style="width: 300px" v-model.trim="form.lifeCode" placeholder="请输入设备代码"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="设备类别" class="rightStyle" prop="lifeKind">
                    <el-select style="width: 300px" v-model="form.lifeKind"
                               @change="getliftType(form.lifeKind,0)"
                               placeholder="请选择设备类别" clearable>
                      <el-option
                              v-for="item in eqptypeList"
                              :key="item"
                              :label="item"
                              :value="item"></el-option>
                    </el-select>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="上端站" class="rightStyle">
                    <el-input v-model.trim="form.upStation" placeholder="请输入上端站"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="设备品种" class="rightStyle" prop="liftType">
                    <el-select style="width: 300px" v-model="form.liftType" placeholder="请选择设备品种"
                               clearable>
                      <el-option
                              v-for="item in liftTypeList"
                              :key="item.liftType"
                              :label="item.liftType"
                              :value="item.liftType"
                      ></el-option>
                    </el-select>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="下端站" class="rightStyle">
                    <el-input v-model.trim="form.downStation" placeholder="请输入下端站"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>

                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="基站" class="rightStyle">
                    <el-input v-model.trim="form.baseStation" placeholder="请输入基站"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="产品型号" class="rightStyle" prop="liftModel">
                    <el-input style="width: 300px" v-model.trim="form.liftModel" placeholder="请输入产品型号"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="产品编号" class="rightStyle" prop="liftNum">
                    <el-input v-model.trim="form.liftNum" placeholder="请输入产品编号"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="悬挂装置规格" class="rightStyle">
                    <el-input v-model.trim="form.hangType" placeholder="请输入悬挂装置规格"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="悬挂装置数量" class="rightStyle">
                    <el-input type="number" v-model="form.hangNum" placeholder="请输入悬挂装置数量"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="制造单位" class="rightStyle" >
                    <el-input style="width: 300px" v-model.trim="form.createUnit" placeholder="请输入制造单位"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="监督检验依据" style="width: 440px" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="form.proof" placeholder="请输入监督检验依据"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50"></el-input>
                  </el-form-item>


                </el-col>
                <el-col :span="12">
                  <el-form-item label="防爆等级" class="rightStyle">
                    <el-input v-model.trim="form.flameProof" placeholder="请输入防爆等级"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="燃爆物质" class="rightStyle">
                    <el-input v-model.trim="form.material" placeholder="请输入燃爆物质"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="制造执行标准" class="rightStyle" prop="createStandard">
                    <el-select style="width: 300px" v-model="form.createStandard"
                               placeholder="请选择制造执行标准" clearable>
                      <el-option label="JG135-2000" value="JG135-2000"></el-option>
                      <el-option label="GB25194-2010" value="GB25194-2010"></el-option>
                      <el-option label="GB7588-1995" value="GB7588-1995"></el-option>
                      <el-option label="GB7588-2003(不含第1号修改单)"
                                 value="GB7588-2003(不含第1号修改单)"></el-option>
                      <el-option label="GB7588-2003（含第1号修改单）"
                                 value="GB7588-2003（含第1号修改单）"></el-option>
                      <el-option label="GB/T16899-2011"
                                 value="GB/T16899-2011"></el-option>
                    </el-select>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="维护保养单位" class="rightStyle" prop="maintenance">
<!--                    <el-input v-model.trim="form.maintenance" style="width: 300px"-->
<!--                              placeholder="请输入维护保养单位"-->
<!--                              clearable autocomplete="off" show-word-limit-->

<!--                              maxlength="50" required></el-input>-->
                    <el-autocomplete
                        class="inline-input"
                        v-model="form.maintenance"
                        clearable
                        :fetch-suggestions="querySearchM"
                        value-key="maintenance"
                        placeholder="请输入维护保养单位"
                        :trigger-on-focus="false"
                        @select="handleSelectM"
                        style="width: 80%"
                    ></el-autocomplete>
                    <el-button  class="iconfont icon-tianjia" size="medium" style="margin-left: 1px; "
                                @click="addUnit(2)" >
                    </el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="整机防爆标志" class="rightStyle">
                    <el-input v-model.trim="form.materialSign" placeholder="请输入整机防爆标志"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="安全钳类型" class="rightStyle">
                    <el-select style="width: 300px" v-model="form.safetyGear" placeholder="请选择安全钳类型"
                               clearable>
                      <el-option label="滚柱型瞬时式" value="滚柱型瞬时式"></el-option>
                      <el-option label="楔块型瞬时式" value="楔块型瞬时式"></el-option>
                      <el-option label="渐进式" value="渐进式"></el-option>
                    </el-select>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="改造单位" class="rightStyle">
                    <el-input v-model.trim="form.updateUnit" placeholder="请输入改造单位"
                              clearable autocomplete="off" show-word-limit
                              style="width: 300px"
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>

                <el-col :span="12">
                  <el-form-item label="受检单位电话" class="rightStyle">
                    <el-input type="number" v-model="form.testedNum" placeholder="请输入受检单位电话"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="缓冲器形式" class="rightStyle">
                    <el-select style="width: 300px" v-model="form.bufferForm" placeholder="请选择缓冲器形式"
                               clearable>
                      <el-option label="非线性蓄能型" value="非线性蓄能型"></el-option>
                      <el-option label="线性蓄能型" value="线性蓄能型"></el-option>
                      <el-option label="耗能型" value="耗能型"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div>
                    <el-form-item label="改造日期格式" prop="updateDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="form.updateDateType"
                                 @change="getDateType(form.updateDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="改造日期" class="rightStyle">
                      <el-date-picker
                              v-model="form.updateDate"
                              type="date"
                              placeholder="改造日期"
                              v-if="form.updateDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.updateDate"
                              type="date"
                              placeholder="改造日期"
                              v-if="form.updateDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.updateDate"
                              type="date"
                              placeholder="改造日期"
                              v-if="form.updateDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </div>

                </el-col>
                <el-col :span="12">
                  <div>
                    <el-form-item label="监督检验日期格式" prop="superviseDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="form.superviseDateType"
                                 @change="getDateType(form.superviseDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="监督检验日期" class="rightStyle">
                      <el-date-picker
                              v-model="form.superviseDate"
                              type="date"
                              placeholder="监督检验日期"
                              v-if="form.superviseDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.superviseDate"
                              type="date"
                              placeholder="监督检验日期"
                              v-if="form.superviseDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.superviseDate"
                              type="date"
                              placeholder="监督检验日期"
                              v-if="form.superviseDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </div>

                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="拖动方式" class="rightStyle">
                    <el-select style="width: 300px" v-model="form.drag" placeholder="请选择 拖动方式"
                               clearable>
                      <el-option label="交流调压调频调速" value="交流调压调频调速"></el-option>
                      <el-option label="交流调压调速" value="交流调压调速"></el-option>
                      <el-option label="交流单速" value="交流单速"></el-option>
                      <el-option label="交流双速" value="交流双速"></el-option>
                      <el-option label="直流调速" value="直流调速"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="监督检测类型" class="rightStyle">
                    <el-select style="width: 300px" v-model="form.superviseType"
                               placeholder="请选择监督检测类型" clearable>
                      <el-option label="安装" value="安装"></el-option>
                      <el-option label="重大修理" value="并联"></el-option>
                      <el-option label="改造" value="改造"></el-option>
                    </el-select>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="制动器形式" class="rightStyle">
                    <el-select style="width: 300px" v-model="form.brakeForm" placeholder="请选择制动器形式"
                               clearable>
                      <el-option label="机电式" value="机电式"></el-option>
                      <el-option label="非机电式" value="非机电式"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="使用登记机关" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="form.organ" placeholder="请输入使用登记机关"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="悬挂装置" class="rightStyle">
                    <el-select style="width: 300px" v-model="form.hang" placeholder="请选择悬挂装置"
                               clearable>
                      <el-option label="钢丝绳" value="钢丝绳"></el-option>
                      <el-option label="链条" value="链条"></el-option>
                      <el-option label="无" value="无"></el-option>
                      <el-option label="钢带" value="钢带"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="紧急救援电话" class="rightStyle">
                    <el-input type="number" style="width: 300px" v-model="form.erpNum"
                              placeholder="请输入紧急救援电话"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="顶升形式" class="rightStyle">
                    <el-select style="width: 300px" v-model="form.jacking" placeholder="请选择顶升形式"
                               clearable>
                      <el-option label="间接式" value="间接式"></el-option>
                      <el-option label="直接式" value="直接式"></el-option>
                      <el-option label="/" value="/"></el-option>
                      <el-option label="钢带" value="钢带"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="安全管理人员" class="rightStyle">
                    <el-input v-model.trim="form.safety" style="width: 300px" placeholder="请输入安全管理人员"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="开门形式" class="rightStyle">
                    <el-select style="width: 300px" v-model="form.openForm" placeholder="请选择开门形式"
                               clearable>
                      <el-option label="自动" value="自动"></el-option>
                      <el-option label="手动" value="手动"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="安全管理人员电话" class="rightStyle">
                    <el-input type="number" style="width: 300px" v-model="form.safetyNum"
                              placeholder="请输入安全管理人员电话"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="名义宽度" class="rightStyle">
                    <el-input style="width: 300px" type="number" v-model="form.nominalWidth"
                              placeholder="请输入名义宽度"
                              :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="重大修理单位" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="form.majorUnit" placeholder="请输入重大修理单位"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="名义速度" class="rightStyle">
                    <el-input type="number" v-model="form.nominalSpeed" placeholder="请输入名义速度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="施工单位" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="form.buildUnit" placeholder="请输入施工单位"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="倾斜角" class="rightStyle">
                    <el-input v-model.trim="form.tilt" placeholder="请输入倾斜角"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="输送能力" class="rightStyle">
                    <el-input v-model.trim="form.conveying" placeholder="请输入输送能力"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>

              </el-row>
              <el-row>
                <el-col :span="12">
                  <div>
                    <el-form-item label="重大修理日期格式" prop="majorDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="form.majorDateType"
                                 @change="getDateType(form.majorDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="重大修理时间" class="rightStyle">
                      <el-date-picker
                              v-model="form.majorDate"
                              type="date"
                              placeholder="重大修理时间"
                              v-if="form.majorDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.majorDate"
                              type="date"
                              placeholder="重大修理时间"
                              v-if="form.majorDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.majorDate"
                              type="date"
                              placeholder="重大修理时间"
                              v-if="form.majorDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>

                    </el-form-item>
                  </div>

                </el-col>
                <el-col :span="12">
                  <div>
                    <el-form-item label="下次检测日期格式" prop="nextDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="form.nextDateType"
                                 @change="getDateType(form.nextDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="下次检测时间" class="rightStyle">
                      <el-date-picker
                              v-model="form.nextDate"
                              type="date"
                              placeholder="下次检测时间"
                              v-if="form.nextDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.nextDate"
                              type="date"
                              placeholder="下次检测时间"
                              v-if="form.nextDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.nextDate"
                              type="date"
                              placeholder="下次检测时间"
                              v-if="form.nextDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>

                    </el-form-item>
                  </div>

                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="提升高度" class="rightStyle">
                    <el-input type="number" v-model="form.liftingHeight" placeholder="请输入提升高度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="轿门位置" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="form.doorPosition" placeholder="请输入轿门位置"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>

              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="使用区段长度" class="rightStyle">
                    <el-input type="number" v-model="form.section" placeholder="请输入使用区段长度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="电动机型号" class="rightStyle">
                    <el-input v-model.trim="form.electricModel" style="width: 300px"
                              placeholder="请输入电动机型号"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="驱动方式" class="rightStyle">
                    <el-select style="width: 300px" v-model="form.driving" placeholder="请选择驱动方式"
                               clearable>
                      <el-option label="曳引式" value="曳引式"></el-option>
                      <el-option label="强制式" value="强制式"></el-option>
                      <el-option label="液压" value="液压"></el-option>
                      <el-option label="齿轮齿条式" value="齿轮齿条式"></el-option>
                    </el-select>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="桥厢尺寸宽度" class="rightStyle">
                    <el-input type="number" style="width: 300px" v-model="form.bridgeBoxWidth"
                              placeholder="请输入桥厢尺寸宽度"
                              :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="机房形式" class="rightStyle">
                    <el-select style="width: 300px" v-model="form.computer" placeholder="请选择机房形式"
                               clearable>
                      <el-option label="有机房" value="有机房"></el-option>
                      <el-option label="无机房" value="无机房"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="桥厢尺寸深度" class="rightStyle">
                    <el-input type="number" style="width: 300px" v-model="form.bridgeBoxDeep"
                              placeholder="请输入桥厢尺寸深度"
                              :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="驱动主机布置" class="rightStyle">
                    <el-select style="width: 300px" v-model="form.assign" placeholder="请选择驱动主机布置"
                               clearable>
                      <el-option label="井道内上置" value="井道内上置"></el-option>
                      <el-option label="井道内下置" value="井道内下置"></el-option>
                      <el-option label="上置机房内" value="上置机房内"></el-option>
                      <el-option label="侧置机房内" value="侧置机房内"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="桥厢尺寸高度" class="rightStyle">
                    <el-input type="number" style="width: 300px" v-model="form.bridgeBoxHigth"
                              placeholder="请输入桥厢尺寸高度"
                              :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div>
                    <el-form-item label="下次检验日期格式" prop="nextTestDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="form.nextTestDateType"
                                 @change="getDateType(form.nextTestDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="下次检验时间" class="rightStyle">
                      <el-date-picker
                              v-model="form.nextTestDate"
                              type="date"
                              placeholder="下次检验时间"
                              v-if="form.nextTestDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.nextTestDate"
                              type="date"
                              placeholder="下次检验时间"
                              v-if="form.nextTestDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.nextTestDate"
                              type="date"
                              placeholder="下次检验时间"
                              v-if="form.nextTestDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>

                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div v-show="form.specialType===2">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="使用单位地址" style="width: 440px">
                    <el-input style="width: 300px" v-model.trim="form.createStandard"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="层数/泊位数" class="rightStyle">
                    <el-input type="number" v-model="form.section" placeholder="请输入层数/泊位数"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="使用单位邮政编码" style="width: 440px">
                    <el-input v-model.trim="form.maintenance"
                              style="width: 300px" placeholder="请输入使用单位邮政编码"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="使用单位代码" prop="unitCode">
                    <el-input v-model.trim="form.unitCode" placeholder="请输入使用单位代码"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="设备使用地点" style="width: 440px">
                    <el-select style="width: 300px" v-model="areaParentIdOne" placeholder="请选择"
                               @change="queryAreaList2"
                               clearable>
                      <el-option v-for="(item, key) in areaList" v-bind:key="item"
                                 :label="item.areaName "
                                 :value="key"></el-option>
                    </el-select>
                    <el-select style="width: 300px" v-model="areaParentIdTwo" placeholder="请选择"
                               @change="queryAreaList3"
                               clearable>
                      <el-option v-for="(item, key) in areaList2" v-bind:key="item"
                                 :label="item.areaName "
                                 :value="key"></el-option>
                    </el-select>
                    <el-select style="width: 300px" v-model="areaParentIdThree" placeholder="请选择"
                               @change="queryAreaList4"
                               clearable>
                      <el-option v-for="(item, key) in areaList3" v-bind:key="item"
                                 :label="item.areaName "
                                 :value="key"></el-option>
                    </el-select>
                    <el-input v-model.trim="form.detailArea" placeholder="请输入具体地址"
                              style="width: 300px;" clearable autocomplete="off" show-word-limit
                              maxlength="500" required></el-input>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <div>
                    <el-form-item label="检验类别" style="width: 440px">

                      <el-select style="width: 300px" v-model="form.testType" placeholder="请选择检验类别"
                                 clearable>
                        <el-option label="首次检验" value="首次检验"></el-option>
                        <el-option label="定期检验" value="定期检验"></el-option>

                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="使用登记证编号" prop="loginNum">
                      <el-input v-model.trim="form.loginNum" class="rightStyle" placeholder="请输入使用登记证编号"
                                clearable autocomplete="off" show-word-limit
                                style="width: 300px"
                                maxlength="50" required></el-input>

                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="单位内编码" class="rightStyle" prop="unitNum">
                      <el-input v-model.trim="form.unitNum" placeholder="请输入单位内编码"
                                clearable autocomplete="off" show-word-limit
                                style="width: 300px"
                                maxlength="50" required></el-input>

                    </el-form-item>
                  </div>

                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">

                  <el-form-item label="设备类别" class="rightStyle" prop="lifeKind">
                    <el-select style="width: 300px" v-model="form.lifeKind"
                               @change="getliftType(form.lifeKind,0)"
                               placeholder="请选择设备类别" clearable>
                      <el-option
                              v-for="item in eqptypeList"
                              :key="item"
                              :label="item"
                              :value="item"></el-option>

                    </el-select>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="设备代码" class="rightStyle" prop="lifeCode">
                    <el-input style="width: 300px" v-model.trim="form.lifeCode" placeholder="请输入设备代码"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="设备品种" class="rightStyle" prop="liftType">
                    <el-select style="width: 300px" v-model="form.liftType"
                               placeholder="请选择设备品种" clearable>
                      <el-option
                              v-for="item in liftTypeList"
                              :key="item.liftType"
                              :label="item.liftType"
                              :value="item.liftType"
                      ></el-option>

                    </el-select>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="产品型号" class="rightStyle" prop="liftModel">
                    <el-input style="width: 300px" v-model.trim="form.liftModel"
                              placeholder="请输入产品型号"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">

                  <el-form-item label="使用单位联系电话" class="rightStyle">
                    <el-input type="number" v-model="form.testedNum" placeholder="请输入受检单位电话"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="产品编号" class="rightStyle" prop="liftNum">
                    <el-input v-model.trim="form.liftNum" placeholder="请输入产品编号"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="制造单位" class="rightStyle" >
                    <el-input style="width: 300px" v-model.trim="form.createUnit"
                              placeholder="请输入制造单位"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="安全管理人员" class="rightStyle">
                    <el-input v-model.trim="form.safety" style="width: 300px" placeholder="请输入安全管理人员"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="重大修理单位" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="form.majorUnit"
                              placeholder="请输入重大修理单位"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="回转速度" class="rightStyle">
                    <el-input type="number" v-model="form.pressure" placeholder="请输入回转速度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="设计使用年限" style="width: 440px">
                    <el-input type="number" v-model="form.hcNum" placeholder="请输入设计使用年限"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="额定起重力矩" class="rightStyle">

                    <el-input type="number" v-model="form.nominalWidth" placeholder="请输入额定起重力矩"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="额定起重量" style="width: 440px">
                    <el-input type="number" v-model="form.maxWeight" placeholder="请输入额定起重量"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="最大幅度" class="rightStyle">
                    <el-input type="number" v-model="form.maxPressure" placeholder="请输入最大幅度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="检验时幅度" style="width: 440px">
                    <el-input v-model.trim="form.tilt" placeholder="请输入检验时幅度"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="检验高度" class="rightStyle">
                    <el-input type="number" v-model="form.bridgeBoxHigth" placeholder="请输入检验高度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="变幅速度" class="rightStyle">
                    <el-input type="number" v-model="form.nominalSpeed" placeholder="请输入变幅速度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="最大独立高度" class="rightStyle">
                    <el-input type="number" v-model="form.bridgeBoxWidth"
                              placeholder="请输入最大独立高度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="最大起升高度" class="rightStyle">
                    <el-input type="number" v-model="form.bridgeBoxDeep" placeholder="请输入最大起升高度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="其他主要参数" class="rightStyle">
                    <el-input v-model.trim="form.electricModel" placeholder="请输入其他主要参数"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="大车(横移)运行速度" class="rightStyle">
                    <el-input type="number" v-model="form.speedUp" placeholder="请输入大车(横移)运行速度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="小车(纵移)运行速度" class="rightStyle">
                    <el-input type="number" v-model="form.speedDown" placeholder="请输入小车(纵移)运行速度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="生产率" class="rightStyle">
                    <el-input type="number" v-model="form.liftingHeight" placeholder="请输入生产率"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="工作级别" class="rightStyle">
                    <el-input v-model.trim="form.flameProof" placeholder="请输入工作级别"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div>
                    <el-form-item label="有效期至左笼日期格式" prop="superviseDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="form.superviseDateType"
                                 @change="getDateType(form.superviseDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="有效期至左笼" class="rightStyle">
                      <el-date-picker
                              v-model="form.superviseDate"
                              type="date"
                              placeholder="有效期至左笼"
                              v-if="form.superviseDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.superviseDate"
                              type="date"
                              placeholder="有效期至左笼"
                              v-if="form.superviseDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.superviseDate"
                              type="date"
                              placeholder="有效期至左笼"
                              v-if="form.superviseDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>

                    </el-form-item>
                  </div>

                </el-col>
                <el-col :span="12">
                  <div>
                    <el-form-item label="有效期至右笼日期格式" prop="majorDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="form.majorDateType"
                                 @change="getDateType(form.majorDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="有效期至右笼" class="rightStyle">
                      <el-date-picker
                              v-model="form.majorDate"
                              type="date"
                              placeholder="有效期至右笼"
                              v-if="form.majorDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.majorDate"
                              type="date"
                              placeholder="有效期至右笼"
                              v-if="form.majorDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.majorDate"
                              type="date"
                              placeholder="有效期至右笼"
                              v-if="form.majorDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </div>

                </el-col>
              </el-row>
              <el-row>

                <el-col :span="12">
                  <div>
                    <el-form-item label="投入使用日期格式" prop="createDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="form.createDateType"
                                 @change="getDateType(form.createDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="投入使用日期" class="rightStyle">
                      <el-date-picker
                              v-model="form.createDate"
                              type="date"
                              placeholder="投入使用日期"
                              v-if="form.createDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.createDate"
                              type="date"
                              placeholder="投入使用日期"
                              v-if="form.createDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.createDate"
                              type="date"
                              placeholder="投入使用日期"
                              v-if="form.createDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </div>

                </el-col>
                <el-col :span="12">
                  <div>
                    <el-form-item label="下次定期检验日期格式" prop="nextTestDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="form.nextTestDateType"
                                 @change="getDateType(form.nextTestDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="下次定期检验日期" class="rightStyle">
                      <el-date-picker
                              v-model="form.nextTestDate"
                              type="date"
                              placeholder="下次定期检验日期"
                              v-if="form.nextTestDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.nextTestDate"
                              type="date"
                              placeholder="下次定期检验日期"
                              v-if="form.nextTestDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="form.nextTestDate"
                              type="date"
                              placeholder="下次定期检验日期"
                              v-if="form.nextTestDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </div>

                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="安装高度" class="rightStyle">
                    <el-input type="number" v-model="form.upStation" placeholder="请输入安装高度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="最大安装高度" class="rightStyle">
                    <el-input type="number" v-model="form.downStation" placeholder="请输入最大安装高度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="自由端高度" class="rightStyle">
                    <el-input type="number" v-model="form.baseStation" placeholder="请输入自由端高度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="最大自由端高度" class="rightStyle">
                    <el-input type="number" v-model="form.hangType" placeholder="请输入最大自由端高度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="防坠安全器型号左笼" class="rightStyle">
                    <el-input type="number" v-model="form.hangNum" placeholder="请输入防坠安全器型号左笼"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="防坠安全器型号右笼" class="rightStyle">
                    <el-input type="number" v-model="form.material" placeholder="请输入防坠安全器型号右笼"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="跨度(工作幅度)" class="rightStyle">
                    <el-input type="number" v-model="form.bufferForm" placeholder="请输入跨度(工作幅度)"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="主起升速度" class="rightStyle">
                    <el-input type="number" v-model="form.safetyGear" placeholder="请输入主起升速度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="防坠安全器编号左笼" class="rightStyle">
                    <el-input type="number" v-model="form.materialSign"
                              placeholder="请输入防坠安全器编号左笼"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="防坠安全器编号右笼" class="rightStyle">
                    <el-input type="number" v-model="form.openForm" placeholder="请输入防坠安全器编号右笼"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="主臂长度" class="rightStyle">
                    <el-input type="number" v-model="form.drag" placeholder="请输入主臂长度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="副起升速度" class="rightStyle">
                    <el-input type="number" v-model="form.brakeForm" placeholder="请输入副起升速度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="固定副臂长" class="rightStyle">
                    <el-input type="number" v-model="form.hang" placeholder="请输入固定副臂长"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="行走速度" class="rightStyle">
                    <el-input type="number" v-model="form.jacking" placeholder="请输入行走速度"
                              style="width: 300px" :min="0" clearable autocomplete="off"
                              show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </el-col>
      </el-row>


      <template #footer>
        <div style="margin: 0 auto ; text-align: center ">
          <el-button @click="closeDialog(0,'form')">关闭</el-button>
          <!--                        <el-button  @click="dialogFormVisible = false">退出</el-button>:disabled="saveIs"-->
          <el-button type="primary" @click="save('form')">确定</el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog v-model="dialogFormVisibleEdit" title="修改设备" :lock-scroll="false"
               width="80%">
      <!--        :fullscreen="true" draggable-->
      <el-row>
        <el-col :span="24">
          <el-form :model="editform" :inline="true" ref="editform" :rules="rules" status-icon label-width="140px">
            <div>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="设备种类" prop="unit" style="width: 440px">
                    <el-select style="width: 300px" v-model="editform.specialType" disabled="true"
                               placeholder="请选择设备种类"
                               clearable>
                      <el-option label="电梯" :value="1"></el-option>
                      <el-option label="起重器" :value="2"></el-option>

                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="使用单位名称" prop="unit" style="width: 440px">
                    <el-input v-model.trim="editform.unit"
                              style="width: 300px" placeholder="请输入使用单位名称"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

            </div>
            <div v-show="editform.specialType===1">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="监察识别码" style="width: 440px" prop="superviseCode">
                    <el-input v-model.trim="editform.superviseCode"
                              style="width: 300px" placeholder="请输入监察识别码"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="额定载重量" prop="maxWeight" style="width: 440px">
                    <el-input-number style="width: 300px" v-model="editform.maxWeight" :precision="1"
                                     :step="1" :min="0"
                                     :max="10000"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="设备使用地点" style="width: 440px">
                    <el-select style="width: 300px" v-model="areaParentIdOne" placeholder="请选择"
                               @change="queryAreaList2"
                               clearable>
                      <el-option v-for="(item, key) in areaList" v-bind:key="item" :label="item.areaName "
                                 :value="key"></el-option>
                    </el-select>
                    <el-select style="width: 300px" v-model="areaParentIdTwo" placeholder="请选择"
                               @change="queryAreaList3"
                               clearable>
                      <el-option v-for="(item, key) in areaList2" v-bind:key="item"
                                 :label="item.areaName "
                                 :value="key"></el-option>
                    </el-select>
                    <el-select style="width: 300px" v-model="areaParentIdThree" placeholder="请选择"
                               @change="queryAreaList4"
                               clearable>
                      <el-option v-for="(item, key) in areaList3" v-bind:key="item"
                                 :label="item.areaName "
                                 :value="key"></el-option>
                    </el-select>
                    <el-input v-model.trim="editform.detailArea" placeholder="请输入具体地址"
                              style="width: 300px;" clearable autocomplete="off" show-word-limit
                              maxlength="500" required></el-input>
                    <!--                <el-select style="width: 300px" v-model="areaParentIdFour" @change="queryAreaList5" placeholder="请选择"-->
                    <!--                           clearable>-->
                    <!--                  <el-option v-for="(item, key) in areaList4" v-bind:key="item" :label="item.areaName "-->
                    <!--                             :value="key"></el-option>-->
                    <!--                </el-select>-->
                    <!--                <el-select style="width: 300px" v-model="areaParentIdFive" placeholder="请选择" clearable>-->
                    <!--                  <el-option v-for="(item, key) in areaList5" v-bind:key="item" :label="item.areaName "-->
                    <!--                             :value="key"></el-option>-->
                    <!--                </el-select>-->
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <div>
                    <el-form-item label="额定压力" class="rightStyle">
                      <el-input type="number" v-model="editform.pressure" placeholder="请输入额定压力"
                                style="width: 300px;" :min="0" clearable autocomplete="off" show-word-limit
                                maxlength="50" required></el-input>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="额定速度" prop="speed" class="rightStyle">
                      <el-input-number style="width: 300px" v-model="editform.speed" :precision="2"
                                       :step="0.1" :min="0"
                                       :max="100"></el-input-number>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="额定速度（上行）" style="width: 440px" class="rightStyle">
                      <el-input-number style="width: 300px" v-model="editform.speedUp" :precision="2"
                                       :step="0.1" :min="0"
                                       :max="100"></el-input-number>
                    </el-form-item>
                  </div>

                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="设备所在区域" style="width: 440px" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="editform.lifeArea" placeholder="请输入设备所在区域"
                              clearable autocomplete="off" show-word-limit maxlength="50"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="楼盘名称" class="rightStyle">
                    <el-input v-model.trim="editform.propertyName" placeholder="请输入楼盘名称"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="分支机构名称" style="width: 440px" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="editform.branchName" placeholder="请输入分支机构名称"
                              clearable autocomplete="off" show-word-limit maxlength="50"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="驱动主机型号" class="rightStyle">
                    <el-input v-model.trim="editform.driveModel" placeholder="请输入驱动主机型号" :min="0"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="驱动主机编号" style="width: 440px" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="editform.driveCode" placeholder="请输入驱动主机编号"
                              clearable autocomplete="off" show-word-limit maxlength="50"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="控制柜型号" class="rightStyle">
                    <el-input v-model.trim="editform.controlBoxModel" placeholder="请输入控制柜型号" :min="0"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="控制柜编号" style="width: 440px" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="editform.controlBoxCode" placeholder="请输入控制柜编号"
                              clearable autocomplete="off" show-word-limit maxlength="50"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="轿厢限速器型号" class="rightStyle">
                    <el-input v-model.trim="editform.carModel" placeholder="请输入轿厢限速器型号"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="轿厢限速器编号" style="width: 440px" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="editform.carCode" placeholder="请输入轿厢限速器编号"
                              clearable autocomplete="off" show-word-limit maxlength="50"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="对重限速器型号" class="rightStyle">
                    <el-input v-model.trim="editform.counterweightModel" placeholder="请输入对重限速器型号"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="对重限速器编号" style="width: 440px" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="editform.counterweightModelCode"
                              placeholder="请输入对重限速器编号"
                              clearable autocomplete="off" show-word-limit maxlength="50"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="使用单位地址" class="rightStyle">
                    <el-input v-model.trim="editform.unitArea" placeholder="请输入使用单位地址"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="分支机构地址" style="width: 440px" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="editform.branchArea" placeholder="请输入分支机构地址"
                              clearable autocomplete="off" show-word-limit maxlength="50"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="楼盘地址" class="rightStyle">
                    <el-input v-model.trim="editform.propertyArea" placeholder="请输入楼盘地址"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>


                <el-col :span="12">
                  <div>
                    <el-form-item label="上次检验日期格式" prop="preDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="editform.preDateType"
                                 @change="getDateType(editform.preDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="上次检验日期" class="rightStyle">
                      <el-date-picker
                              v-model="editform.preDate"
                              type="date"
                              placeholder="上次检验日期"
                              v-if="editform.preDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.preDate"
                              type="date"
                              placeholder="上次检验日期"
                              v-if="editform.preDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.preDate"
                              type="date"
                              placeholder="上次检验日期"
                              v-if="editform.preDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </div>

                </el-col>
                <el-col :span="12">
                  <div>
                    <el-form-item label="制造时间日期格式" prop="createDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="editform.createDateType"
                                 @change="getDateType(editform.createDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="制造时间" class="rightStyle" prop="createDate">
                      <el-date-picker
                              v-model="editform.createDate"
                              type="date"
                              placeholder="制造时间"
                              v-if="editform.createDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.createDate"
                              type="date"
                              placeholder="制造时间"
                              v-if="editform.createDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.createDate"
                              type="date"
                              placeholder="制造时间"
                              v-if="editform.createDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </div>

                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="额定速度（下行）" style="width: 440px" class="rightStyle">
                    <el-input-number style="width: 300px" v-model="editform.speedDown" :precision="2"
                                     :step="0.1" :min="0"
                                     :max="100"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="油缸数量" class="rightStyle">
                    <el-input type="number" v-model="editform.hcNum" placeholder="请输入油缸数量" :min="0"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="满载压力" class="rightStyle">
                    <el-input type="number" v-model="editform.maxPressure" :min="0" placeholder="请输入满载压力"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="使用单位代码" prop="unitCode">
                    <el-input v-model.trim="editform.unitCode" placeholder="请输入使用单位代码"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="层" class="rightStyle" prop="storey">
                    <el-input type="number" :min="0" v-model="editform.storey" placeholder="请输入层数"
                              clearable autocomplete="off" show-word-limit style="width: 300px"
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="使用登记证编号" prop="loginNum">
                    <el-input v-model.trim="editform.loginNum" class="rightStyle" placeholder="请输入使用登记证编号"
                              clearable autocomplete="off" show-word-limit
                              style="width: 300px"
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="站" class="rightStyle" prop="stand">
                    <el-input type="number" v-model="editform.stand" placeholder="请输入站数"
                              :min="0" clearable autocomplete="off" show-word-limit
                              style="width: 300px"
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="单位内编码" class="rightStyle" prop="unitNum">
                    <el-input v-model.trim="editform.unitNum" placeholder="请输入单位内编码"
                              clearable autocomplete="off" show-word-limit
                              style="width: 300px"
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="门" class="rightStyle" prop="door">
                    <el-input type="number" v-model="editform.door" :min="0" placeholder="请输入门数"
                              clearable autocomplete="off" show-word-limit style="width: 300px"
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="设备注册代码" class="rightStyle" prop="lifeRegistCode">
                    <el-input style="width: 300px" v-model.trim="editform.lifeRegistCode" placeholder="请输入设备注册代码"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>

                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="控制方式" class="rightStyle" prop="controller">
                    <el-select style="width: 300px" v-model="editform.controller" placeholder="请选择控制方式"
                               clearable>
                      <el-option label="集选" value="集选"></el-option>
                      <el-option label="并联" value="并联"></el-option>
                      <el-option label="群控" value="群控"></el-option>
                      <el-option label="按钮" value="按钮"></el-option>
                      <el-option label="信号控制" value="信号控制"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="设备代码" class="rightStyle" prop="lifeCode">
                    <el-input style="width: 300px" v-model.trim="editform.lifeCode" placeholder="请输入设备代码"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="设备类别" class="rightStyle" prop="lifeKind">
                    <el-select style="width: 300px" v-model="editform.lifeKind"
                               @change="getliftType(editform.lifeKind,1)"
                               placeholder="请选择设备类别" clearable>
                      <el-option
                              v-for="item in eqptypeList"
                              :key="item"
                              :label="item"
                              :value="item"></el-option>
                    </el-select>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="上端站" class="rightStyle">
                    <el-input v-model.trim="editform.upStation" placeholder="请输入上端站"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="设备品种" class="rightStyle" prop="liftType">
                    <el-select style="width: 300px" v-model="editform.liftType" placeholder="请选择设备品种"
                               clearable>
                      <el-option
                              v-for="item in liftTypeList"
                              :key="item.liftType"
                              :label="item.liftType"
                              :value="item.liftType"
                      ></el-option>
                    </el-select>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="下端站" class="rightStyle">
                    <el-input v-model.trim="editform.downStation" placeholder="请输入下端站"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>

                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="基站" class="rightStyle">
                    <el-input v-model.trim="editform.baseStation" placeholder="请输入基站"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="产品型号" class="rightStyle" prop="liftModel">
                    <el-input style="width: 300px" v-model.trim="editform.liftModel" placeholder="请输入产品型号"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="产品编号" class="rightStyle" prop="liftNum">
                    <el-input v-model.trim="editform.liftNum" placeholder="请输入产品编号"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="悬挂装置规格" class="rightStyle">
                    <el-input v-model.trim="editform.hangType" placeholder="请输入悬挂装置规格"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="悬挂装置数量" class="rightStyle">
                    <el-input type="number" v-model="editform.hangNum" placeholder="请输入悬挂装置数量"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="制造单位" class="rightStyle" >
                    <el-input style="width: 300px" v-model.trim="editform.createUnit" placeholder="请输入制造单位"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>

                <el-col :span="12">
                  <el-form-item label="监督检验依据" style="width: 440px" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="editform.proof" placeholder="请输入监督检验依据"
                              clearable autocomplete="off" show-word-limit maxlength="50"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="防爆等级" class="rightStyle">
                    <el-input v-model.trim="editform.flameProof" placeholder="请输入防爆等级"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="燃爆物质" class="rightStyle">
                    <el-input v-model.trim="editform.material" placeholder="请输入燃爆物质"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="制造执行标准" class="rightStyle" prop="createStandard">
                    <el-select style="width: 300px" v-model="editform.createStandard"
                               placeholder="请选择制造执行标准" clearable>
                      <el-option label="JG135-2000" value="JG135-2000"></el-option>
                      <el-option label="GB25194-2010" value="GB25194-2010"></el-option>
                      <el-option label="GB7588-1995" value="GB7588-1995"></el-option>
                      <el-option label="GB7588-2003(不含第1号修改单)" value="GB7588-2003(不含第1号修改单)"></el-option>
                      <el-option label="GB7588-2003（含第1号修改单）" value="GB7588-2003（含第1号修改单）"></el-option>
                      <el-option label="GB/T16899-2011"
                                 value="GB/T16899-2011"></el-option>
                    </el-select>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="维护保养单位" class="rightStyle" prop="maintenance">
                    <el-input v-model.trim="editform.maintenance" style="width: 300px" placeholder="请输入维护保养单位"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="整机防爆标志" class="rightStyle">
                    <el-input v-model.trim="editform.materialSign" placeholder="请输入整机防爆标志"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="安全钳类型" class="rightStyle">
                    <el-select style="width: 300px" v-model="editform.safetyGear" placeholder="请选择安全钳类型"
                               clearable>
                      <el-option label="滚柱型瞬时式" value="滚柱型瞬时式"></el-option>
                      <el-option label="楔块型瞬时式" value="楔块型瞬时式"></el-option>
                      <el-option label="渐进式" value="渐进式"></el-option>
                    </el-select>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="改造单位" class="rightStyle">
                    <el-input v-model.trim="editform.updateUnit" placeholder="请输入改造单位"
                              clearable autocomplete="off" show-word-limit
                              style="width: 300px"
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>

                <el-col :span="12">
                  <el-form-item label="受检单位电话" class="rightStyle">
                    <el-input type="number" v-model="editform.testedNum" placeholder="请输入受检单位电话"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="缓冲器形式" class="rightStyle">
                    <el-select style="width: 300px" v-model="editform.bufferForm" placeholder="请选择缓冲器形式"
                               clearable>
                      <el-option label="非线性蓄能型" value="非线性蓄能型"></el-option>
                      <el-option label="线性蓄能型" value="线性蓄能型"></el-option>
                      <el-option label="耗能型" value="耗能型"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div>
                    <el-form-item label="改造日期格式" prop="updateDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="editform.updateDateType"
                                 @change="getDateType(editform.updateDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="改造日期" class="rightStyle">
                      <el-date-picker
                              v-model="editform.updateDate"
                              type="date"
                              placeholder="改造日期"
                              v-if="editform.updateDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.updateDate"
                              type="date"
                              placeholder="改造日期"
                              v-if="editform.updateDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.updateDate"
                              type="date"
                              placeholder="改造日期"
                              v-if="editform.updateDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </div>

                </el-col>
                <el-col :span="12">
                  <div>
                    <el-form-item label="监督检验日期格式" prop="superviseDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="editform.superviseDateType"
                                 @change="getDateType(editform.superviseDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="监督检验日期" class="rightStyle">
                      <el-date-picker
                              v-model="editform.superviseDate"
                              type="date"
                              placeholder="监督检验日期"
                              v-if="editform.superviseDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.superviseDate"
                              type="date"
                              placeholder="监督检验日期"
                              v-if="editform.superviseDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.superviseDate"
                              type="date"
                              placeholder="监督检验日期"
                              v-if="editform.superviseDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>

                    </el-form-item>
                  </div>

                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="拖动方式" class="rightStyle">
                    <el-select style="width: 300px" v-model="editform.drag" placeholder="请选择 拖动方式"
                               clearable>
                      <el-option label="交流调压调频调速" value="交流调压调频调速"></el-option>
                      <el-option label="交流调压调速" value="交流调压调速"></el-option>
                      <el-option label="交流单速" value="交流单速"></el-option>
                      <el-option label="交流双速" value="交流双速"></el-option>
                      <el-option label="直流调速" value="直流调速"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="监督检测类型" class="rightStyle">
                    <el-select style="width: 300px" v-model="editform.superviseType" placeholder="请选择监督检测类型"
                               clearable>
                      <el-option label="安装" value="安装"></el-option>
                      <el-option label="重大修理" value="并联"></el-option>
                      <el-option label="改造" value="改造"></el-option>
                    </el-select>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="制动器形式" class="rightStyle">
                    <el-select style="width: 300px" v-model="editform.brakeForm" placeholder="请选择制动器形式"
                               clearable>
                      <el-option label="机电式" value="机电式"></el-option>
                      <el-option label="非机电式" value="非机电式"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="使用登记机关" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="editform.organ" placeholder="请输入使用登记机关"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="悬挂装置" class="rightStyle">
                    <el-select style="width: 300px" v-model="editform.hang" placeholder="请选择悬挂装置" clearable>
                      <el-option label="钢丝绳" value="钢丝绳"></el-option>
                      <el-option label="链条" value="链条"></el-option>
                      <el-option label="无" value="无"></el-option>
                      <el-option label="钢带" value="钢带"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="紧急救援电话" class="rightStyle">
                    <el-input type="number" style="width: 300px" v-model="editform.erpNum"
                              placeholder="请输入紧急救援电话"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="顶升形式" class="rightStyle">
                    <el-select style="width: 300px" v-model="editform.jacking" placeholder="请选择顶升形式"
                               clearable>
                      <el-option label="间接式" value="间接式"></el-option>
                      <el-option label="直接式" value="直接式"></el-option>
                      <el-option label="/" value="/"></el-option>
                      <el-option label="钢带" value="钢带"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="安全管理人员" class="rightStyle">
                    <el-input v-model.trim="editform.safety" style="width: 300px" placeholder="请输入安全管理人员"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="开门形式" class="rightStyle">
                    <el-select style="width: 300px" v-model="editform.openForm" placeholder="请选择开门形式"
                               clearable>
                      <el-option label="自动" value="自动"></el-option>
                      <el-option label="手动" value="手动"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="安全管理人员电话" class="rightStyle">
                    <el-input type="number" style="width: 300px" v-model="editform.safetyNum"
                              placeholder="请输入安全管理人员电话"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="名义宽度" class="rightStyle">
                    <el-input style="width: 300px" type="number" v-model="editform.nominalWidth"
                              placeholder="请输入名义宽度"
                              :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="重大修理单位" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="editform.majorUnit" placeholder="请输入重大修理单位"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="名义速度" class="rightStyle">
                    <el-input type="number" v-model="editform.nominalSpeed" placeholder="请输入名义速度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="施工单位" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="editform.buildUnit" placeholder="请输入施工单位"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="倾斜角" class="rightStyle">
                    <el-input type="number" v-model="editform.tilt" placeholder="请输入倾斜角"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="输送能力" class="rightStyle">
                    <el-input v-model.trim="editform.conveying" placeholder="请输入输送能力"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>

              </el-row>
              <el-row>
                <el-col :span="12">
                  <div>
                    <el-form-item label="重大修理日期格式" prop="majorDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="editform.majorDateType"
                                 @change="getDateType(editform.majorDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="重大修理时间" class="rightStyle">
                      <el-date-picker
                              v-model="editform.majorDate"
                              type="date"
                              placeholder="重大修理时间"
                              v-if="editform.majorDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.majorDate"
                              type="date"
                              placeholder="重大修理时间"
                              v-if="editform.majorDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.majorDate"
                              type="date"
                              placeholder="重大修理时间"
                              v-if="editform.majorDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>

                    </el-form-item>
                  </div>

                </el-col>
                <el-col :span="12">
                  <div>
                    <el-form-item label="下次检测日期格式" prop="nextDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="editform.nextDateType"
                                 @change="getDateType(editform.nextDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="下次检测时间" class="rightStyle">
                      <el-date-picker
                              v-model="editform.nextDate"
                              type="date"
                              placeholder="下次检测时间"
                              v-if="editform.nextDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.nextDate"
                              type="date"
                              placeholder="下次检测时间"
                              v-if="editform.nextDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.nextDate"
                              type="date"
                              placeholder="下次检测时间"
                              v-if="editform.nextDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>

                    </el-form-item>
                  </div>

                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="提升高度" class="rightStyle">
                    <el-input type="number" v-model="editform.liftingHeight" placeholder="请输入提升高度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="轿门位置" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="editform.doorPosition" placeholder="请输入轿门位置"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="使用区段长度" class="rightStyle">
                    <el-input type="number" v-model="editform.section" placeholder="请输入使用区段长度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="电动机型号" class="rightStyle">
                    <el-input v-model.trim="editform.electricModel" style="width: 300px" placeholder="请输入电动机型号"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="驱动方式" class="rightStyle">
                    <el-select style="width: 300px" v-model="editform.driving" placeholder="请选择驱动方式"
                               clearable>
                      <el-option label="曳引式" value="曳引式"></el-option>
                      <el-option label="强制式" value="强制式"></el-option>
                      <el-option label="液压" value="液压"></el-option>
                      <el-option label="齿轮齿条式" value="齿轮齿条式"></el-option>
                    </el-select>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="桥厢尺寸宽度" class="rightStyle">
                    <el-input type="number" style="width: 300px" v-model="editform.bridgeBoxWidth"
                              placeholder="请输入桥厢尺寸宽度"
                              :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="机房形式" class="rightStyle">
                    <el-select style="width: 300px" v-model="editform.computer" placeholder="请选择机房形式"
                               clearable>
                      <el-option label="有机房" value="有机房"></el-option>
                      <el-option label="无机房" value="无机房"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="桥厢尺寸深度" class="rightStyle">
                    <el-input type="number" style="width: 300px" v-model="editform.bridgeBoxDeep"
                              placeholder="请输入桥厢尺寸深度"
                              :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="驱动主机布置" class="rightStyle">
                    <el-select style="width: 300px" v-model="editform.assign" placeholder="请选择驱动主机布置"
                               clearable>
                      <el-option label="井道内上置" value="井道内上置"></el-option>
                      <el-option label="井道内下置" value="井道内下置"></el-option>
                      <el-option label="上置机房内" value="上置机房内"></el-option>
                      <el-option label="侧置机房内" value="侧置机房内"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="桥厢尺寸高度" class="rightStyle">
                    <el-input type="number" style="width: 300px" v-model="editform.bridgeBoxHigth"
                              placeholder="请输入桥厢尺寸高度"
                              :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div>
                    <el-form-item label="下次检验日期格式" prop="nextTestDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="editform.nextTestDateType"
                                 @change="getDateType(editform.nextTestDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="下次检验时间" class="rightStyle">
                      <el-date-picker
                              v-model="editform.nextTestDate"
                              type="date"
                              placeholder="下次检验时间"
                              v-if="editform.nextTestDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.nextTestDate"
                              type="date"
                              placeholder="下次检验时间"
                              v-if="editform.nextTestDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.nextTestDate"
                              type="date"
                              placeholder="下次检验时间"
                              v-if="editform.nextTestDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>

                    </el-form-item>
                  </div>

                </el-col>


              </el-row>
            </div>
            <div v-show="editform.specialType===2">
              <el-row>

                <el-col :span="12">
                  <el-form-item label="使用单位地址" style="width: 440px" prop="createStandard">
                    <el-input style="width: 300px" v-model.trim="editform.createStandard"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="层数/泊位数" class="rightStyle">
                    <el-input type="number" v-model="editform.section" placeholder="请输入层数/泊位数"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="使用单位邮政编码" style="width: 440px">
                    <el-input v-model.trim="editform.maintenance"
                              style="width: 300px" placeholder="请输入使用单位邮政编码"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="使用单位代码" prop="unitCode">
                    <el-input v-model.trim="editform.unitCode" placeholder="请输入使用单位代码"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="设备使用地点" style="width: 440px">
                    <el-select style="width: 300px" v-model="areaParentIdOne" placeholder="请选择"
                               @change="queryAreaList2"
                               clearable>
                      <el-option v-for="(item, key) in areaList" v-bind:key="item" :label="item.areaName "
                                 :value="key"></el-option>
                    </el-select>
                    <el-select style="width: 300px" v-model="areaParentIdTwo" placeholder="请选择"
                               @change="queryAreaList3"
                               clearable>
                      <el-option v-for="(item, key) in areaList2" v-bind:key="item"
                                 :label="item.areaName "
                                 :value="key"></el-option>
                    </el-select>
                    <el-select style="width: 300px" v-model="areaParentIdThree" placeholder="请选择"
                               @change="queryAreaList4"
                               clearable>
                      <el-option v-for="(item, key) in areaList3" v-bind:key="item"
                                 :label="item.areaName "
                                 :value="key"></el-option>
                    </el-select>
                    <el-input v-model.trim="editform.detailArea" placeholder="请输入具体地址"
                              style="width: 300px;" clearable autocomplete="off" show-word-limit
                              maxlength="500" required></el-input>
                    <!--                <el-select style="width: 300px" v-model="areaParentIdFour" @change="queryAreaList5" placeholder="请选择"-->
                    <!--                           clearable>-->
                    <!--                  <el-option v-for="(item, key) in areaList4" v-bind:key="item" :label="item.areaName "-->
                    <!--                             :value="key"></el-option>-->
                    <!--                </el-select>-->
                    <!--                <el-select style="width: 300px" v-model="areaParentIdFive" placeholder="请选择" clearable>-->
                    <!--                  <el-option v-for="(item, key) in areaList5" v-bind:key="item" :label="item.areaName "-->
                    <!--                             :value="key"></el-option>-->
                    <!--                </el-select>-->
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <div>
                    <el-form-item label="检验类别" style="width: 440px">

                      <el-select style="width: 300px" v-model="editform.testType" placeholder="请选择检验类别"
                                 clearable>
                        <el-option label="首次检验" value="首次检验"></el-option>
                        <el-option label="定期检验" value="定期检验"></el-option>

                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="使用登记证编号" prop="loginNum" class="rightStyle">
                      <el-input v-model.trim="editform.loginNum" placeholder="请输入使用登记证编号"
                                clearable autocomplete="off" show-word-limit
                                style="width: 300px"
                                maxlength="50" required></el-input>

                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="单位内编码" class="rightStyle" prop="unitNum">
                      <el-input v-model.trim="editform.unitNum" placeholder="请输入单位内编码"
                                clearable autocomplete="off" show-word-limit
                                style="width: 300px"
                                maxlength="50" required></el-input>

                    </el-form-item>
                  </div>

                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="设备类别" class="rightStyle" prop="lifeKind">
                    <el-select style="width: 300px" v-model="editform.lifeKind"
                               @change="getliftType(editform.lifeKind,1)"
                               placeholder="请选择设备类别" clearable>
                      <el-option
                              v-for="item in eqptypeList"
                              :key="item"
                              :label="item"
                              :value="item"></el-option>

                    </el-select>

                  </el-form-item>

                </el-col>
                <el-col :span="12">
                  <el-form-item label="设备代码" class="rightStyle" prop="lifeCode">
                    <el-input style="width: 300px" v-model.trim="editform.lifeCode" placeholder="请输入设备代码"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>

                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="设备品种" class="rightStyle" prop="liftType">
                    <el-select style="width: 300px" v-model="editform.liftType" placeholder="请选择设备品种"
                               clearable>
                      <el-option
                              v-for="item in liftTypeList"
                              :key="item.liftType"
                              :label="item.liftType"
                              :value="item.liftType"
                      ></el-option>

                    </el-select>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="产品型号" class="rightStyle" prop="liftModel">
                    <el-input style="width: 300px" v-model.trim="editform.liftModel" placeholder="请输入产品型号"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">

                  <el-form-item label="使用单位联系电话" class="rightStyle">
                    <el-input type="number" v-model="editform.testedNum" placeholder="请输入受检单位电话"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="产品编号" class="rightStyle" prop="liftNum">
                    <el-input v-model.trim="editform.liftNum" placeholder="请输入产品编号"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="制造单位" class="rightStyle" >
                    <el-input style="width: 300px" v-model.trim="editform.createUnit" placeholder="请输入制造单位"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="安全管理人员" class="rightStyle">
                    <el-input v-model.trim="editform.safety" style="width: 300px" placeholder="请输入安全管理人员"
                              clearable autocomplete="off" show-word-limit

                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="重大修理单位" class="rightStyle">
                    <el-input style="width: 300px" v-model.trim="editform.majorUnit" placeholder="请输入重大修理单位"
                              clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="回转速度" class="rightStyle">
                    <el-input type="number" v-model="editform.pressure" placeholder="请输入回转速度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>

              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="设计使用年限" style="width: 440px">
                    <el-input type="number" v-model="editform.hcNum" placeholder="请输入设计使用年限"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="额定起重力矩" class="rightStyle">

                    <el-input type="number" v-model="editform.nominalWidth" placeholder="请输入额定起重力矩"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="额定起重量" style="width: 440px">
                    <el-input type="number" v-model="editform.maxWeight" placeholder="请输入额定起重量"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="最大幅度" class="rightStyle">
                    <el-input type="number" v-model="editform.maxPressure" placeholder="请输入最大幅度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="检验时幅度" style="width: 440px">
                    <el-input type="number" v-model="editform.tilt" placeholder="请输入检验时幅度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="检验高度" class="rightStyle">
                    <el-input type="number" v-model="editform.bridgeBoxHigth" placeholder="请输入检验高度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="变幅速度" class="rightStyle">
                    <el-input type="number" v-model="editform.nominalSpeed" placeholder="请输入变幅速度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="最大独立高度" class="rightStyle">
                    <el-input type="number" v-model="editform.bridgeBoxWidth" placeholder="请输入最大独立高度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="最大起升高度" class="rightStyle">
                    <el-input type="number" v-model="editform.bridgeBoxDeep" placeholder="请输入最大起升高度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="其他主要参数" class="rightStyle">
                    <el-input v-model.trim="editform.electricModel" placeholder="请输入其他主要参数"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="大车(横移)运行速度" class="rightStyle">
                    <el-input type="number" v-model="editform.speedUp" placeholder="请输入大车(横移)运行速度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="小车(纵移)运行速度" class="rightStyle">
                    <el-input type="number" v-model="editform.speedDown" placeholder="请输入小车(纵移)运行速度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="生产率" class="rightStyle">
                    <el-input type="number" v-model="editform.liftingHeight" placeholder="请输入生产率"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="工作级别" class="rightStyle">
                    <el-input v-model.trim="editform.flameProof" placeholder="请输入工作级别"
                              style="width: 300px" clearable autocomplete="off" show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <div>
                    <el-form-item label="有效期至左笼日期格式" prop="superviseDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="editform.superviseDateType"
                                 @change="getDateType(editform.superviseDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="有效期至左笼" class="rightStyle">
                      <el-date-picker
                              v-model="editform.superviseDate"
                              type="date"
                              placeholder="有效期至左笼"
                              v-if="editform.superviseDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.superviseDate"
                              type="date"
                              placeholder="有效期至左笼"
                              v-if="editform.superviseDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.superviseDate"
                              type="date"
                              placeholder="有效期至左笼"
                              v-if="editform.superviseDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>

                    </el-form-item>
                  </div>

                </el-col>
                <el-col :span="12">
                  <div>
                    <el-form-item label="有效期至右笼日期格式" prop="majorDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="editform.majorDateType"
                                 @change="getDateType(editform.majorDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="有效期至右笼" class="rightStyle">
                      <el-date-picker
                              v-model="editform.majorDate"
                              type="date"
                              placeholder="有效期至右笼"
                              v-if="editform.majorDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.majorDate"
                              type="date"
                              placeholder="有效期至右笼"
                              v-if="editform.majorDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.majorDate"
                              type="date"
                              placeholder="有效期至右笼"
                              v-if="editform.majorDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </div>

                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div>
                    <el-form-item label="投入使用日期格式" prop="createDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="editform.createDateType"
                                 @change="getDateType(editform.createDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="投入使用日期" class="rightStyle">
                      <el-date-picker
                              v-model="editform.createDate"
                              type="date"
                              placeholder="投入使用日期"
                              v-if="editform.createDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.createDate"
                              type="date"
                              placeholder="投入使用日期"
                              v-if="editform.createDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.createDate"
                              type="date"
                              placeholder="投入使用日期"
                              v-if="editform.createDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </div>

                </el-col>
                <el-col :span="12">
                  <div>
                    <el-form-item label="下次定期检验日期格式" prop="nextTestDateType" style="width: 440px">
                      <el-select style="width: 300px" v-model="editform.nextTestDateType"
                                 @change="getDateType(editform.nextTestDateType)"
                                 placeholder="请选择日期格式" clearable>
                        <el-option label="年月日" :value="'年月日'"></el-option>
                        <el-option label="年月" :value="'年月'"></el-option>
                        <el-option label="年" :value="'年'"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="下次定期检验日期" class="rightStyle">
                      <el-date-picker
                              v-model="editform.nextTestDate"
                              type="date"
                              placeholder="下次定期检验日期"
                              v-if="editform.nextTestDateType==='年月日'"
                              format="YYYY年MM月DD日"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.nextTestDate"
                              type="date"
                              placeholder="下次定期检验日期"
                              v-if="editform.nextTestDateType==='年月'"
                              format="YYYY年MM月"
                              style="width: 300px"
                      >
                      </el-date-picker>
                      <el-date-picker
                              v-model="editform.nextTestDate"
                              type="date"
                              placeholder="下次定期检验日期"
                              v-if="editform.nextTestDateType==='年'"
                              format="YYYY年"
                              style="width: 300px"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </div>

                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="安装高度" class="rightStyle">
                    <el-input type="number" v-model="editform.upStation" placeholder="请输入安装高度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="最大安装高度" class="rightStyle">
                    <el-input type="number" v-model="editform.downStation" placeholder="请输入最大安装高度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="自由端高度" class="rightStyle">
                    <el-input type="number" v-model="editform.baseStation" placeholder="请输入自由端高度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="最大自由端高度" class="rightStyle">
                    <el-input type="number" v-model="editform.hangType" placeholder="请输入最大自由端高度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="防坠安全器型号左笼" class="rightStyle">
                    <el-input type="number" v-model="editform.hangNum" placeholder="请输入防坠安全器型号左笼"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="防坠安全器型号右笼" class="rightStyle">
                    <el-input type="number" v-model="editform.material" placeholder="请输入防坠安全器型号右笼"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="跨度(工作幅度)" class="rightStyle">
                    <el-input type="number" v-model="editform.bufferForm" placeholder="请输入跨度(工作幅度)"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="主起升速度" class="rightStyle">
                    <el-input type="number" v-model="editform.safetyGear" placeholder="请输入主起升速度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="防坠安全器编号左笼" class="rightStyle">
                    <el-input type="number" v-model="editform.materialSign" placeholder="请输入防坠安全器编号左笼"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="防坠安全器编号右笼" class="rightStyle">
                    <el-input type="number" v-model="editform.openForm" placeholder="请输入防坠安全器编号右笼"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="主臂长度" class="rightStyle">
                    <el-input type="number" v-model="editform.drag" placeholder="请输入主臂长度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="副起升速度" class="rightStyle">
                    <el-input type="number" v-model="editform.brakeForm" placeholder="请输入副起升速度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="固定副臂长" class="rightStyle">
                    <el-input type="number" v-model="editform.hang" placeholder="请输入固定副臂长"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="50" required></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="行走速度" class="rightStyle">
                    <el-input type="number" v-model="editform.jacking" placeholder="请输入行走速度"
                              style="width: 300px" :min="0" clearable autocomplete="off" show-word-limit
                              maxlength="200" required></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </el-col>
      </el-row>
      <template #footer>
        <div style="margin: 0 auto ; text-align: center ">
          <el-button @click="closeDialog(1,'editform')">关闭</el-button>
          <!--          <el-button    @click="dialogFormVisibleEdit = false">退出</el-button>:disabled="isupdate"-->
          <el-button type="primary" @click="edit('editform')">确定</el-button>
        </div>

      </template>
    </el-dialog>

    <el-dialog v-model="dialogFormVisibleUnit" title="添加使用单位" :lock-scroll="false"
               width="36%">

      <el-form :model="formUnit" ref="formUnit" :rules="rulesAdd" status-icon label-width="160px">
        <el-form-item label="使用单位名称" prop="unit">
          <el-input v-model.trim="formUnit.unit"
                    placeholder="请输入使用单位名称"
                    style="width: 300px"
                    clearable autocomplete="off" show-word-limit
                    maxlength="50" required></el-input>
        </el-form-item>
        <el-form-item label="使用单位名称地址" prop="unitArea">
          <el-input v-model.trim="formUnit.unitArea"
                    placeholder="请输入使用单位名称地址"
                    style="width: 300px"
                    clearable autocomplete="off" show-word-limit
                    maxlength="200" required></el-input>
        </el-form-item>
        <el-form-item label="使用单位代码" prop="unitCode">
          <el-input v-model.trim="formUnit.unitCode"
                    placeholder="请输入使用单位代码"
                    style="width: 300px"
                    clearable autocomplete="off" show-word-limit
                    maxlength="200" required></el-input>
        </el-form-item>
        <el-form-item label="安全管理人员"  >
          <el-input v-model.trim="formUnit.safety"
                    placeholder="请输入安全管理人员"
                    style="width: 300px"
                    clearable autocomplete="off" show-word-limit
                    maxlength="50" required></el-input>
        </el-form-item>
        <el-form-item label="安全管理人员电话"  >
          <el-input v-model.trim="formUnit.safetyNum"
                    placeholder="请输入安全管理人员电话"
                    style="width: 300px"
                    clearable autocomplete="off" show-word-limit
                    maxlength="50" required></el-input>
        </el-form-item>
        <el-form-item label="受检单位电话"  >
          <el-input v-model.trim="formUnit.testedNum"
                    placeholder="请输入受检单位电话"
                    style="width: 300px"
                    clearable autocomplete="off" show-word-limit
                    maxlength="50" required></el-input>
        </el-form-item>
        <el-form-item label="楼盘名称"  >
          <el-input v-model.trim="formUnit.propertyName"
                    placeholder="请输入楼盘名称"
                    style="width: 300px"
                    clearable autocomplete="off" show-word-limit
                    maxlength="200" required></el-input>
        </el-form-item>
        <el-form-item label="楼盘地址"  >
          <el-input v-model.trim="formUnit.propertyArea"
                    placeholder="请输入楼盘地址"
                    style="width: 300px"
                    clearable autocomplete="off" show-word-limit
                    maxlength="200" required></el-input>
        </el-form-item>
      </el-form>

      <template #footer>
        <div style="margin: 0 auto ; text-align: center ">
          <el-button @click="closeDialog(2,'formUnit')">关闭</el-button>
          <el-button type="primary" @click="saveUnit('formUnit')">确定</el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog v-model="dialogFormVisibleM" title="添加维保单位" :lock-scroll="false"
               width="36%">

      <el-form :model="formMaintenancet" ref="formMaintenancet" :rules="rulesAdd" status-icon label-width="160px">
        <el-form-item label="维护保养单位" prop="maintenance">
          <el-input v-model.trim="formMaintenancet.maintenance"
                    placeholder="请输入维护保养单位名称"
                    style="width: 300px"
                    clearable autocomplete="off" show-word-limit
                    maxlength="50" required></el-input>
        </el-form-item>
        <el-form-item label="制造单位" >
          <el-input v-model.trim="formMaintenancet.createUnit"
                    placeholder="请输入制造单位名称"
                    style="width: 300px"
                    clearable autocomplete="off" show-word-limit
                    maxlength="200" required></el-input>
        </el-form-item>
        <el-form-item label="改造单位" prop="updateUnit">
          <el-input v-model.trim="formMaintenancet.updateUnit"
                    placeholder="请输入改造单位名称"
                    style="width: 300px"
                    clearable autocomplete="off" show-word-limit
                    maxlength="200" required></el-input>
        </el-form-item>
        <el-form-item label="重大修改单位" prop="majorUnit" >
          <el-input v-model.trim="formMaintenancet.majorUnit"
                    placeholder="请输入重大修改单位名称"
                    style="width: 300px"
                    clearable autocomplete="off" show-word-limit
                    maxlength="50" required></el-input>
        </el-form-item>
        <el-form-item label="施工单位" prop="buildUnit" >
          <el-input v-model.trim="formMaintenancet.buildUnit"
                    placeholder="请输入施工单位名称"
                    style="width: 300px"
                    clearable autocomplete="off" show-word-limit
                    maxlength="50" required></el-input>
        </el-form-item>
        <el-form-item label="紧急救援电话" prop="erpNum" >
          <el-input v-model.trim="formMaintenancet.erpNum"
                    placeholder="请输入紧急救援电话"
                    style="width: 300px"
                    clearable autocomplete="off" show-word-limit
                    maxlength="50" required></el-input>
        </el-form-item>
        <el-form-item label="维护保养联系人" prop="erpby" >
          <el-input v-model.trim="formMaintenancet.erpby"
                    placeholder="请输入维护保养联系人"
                    style="width: 300px"
                    clearable autocomplete="off" show-word-limit
                    maxlength="200" required></el-input>
        </el-form-item>
      </el-form>

      <template #footer>
        <div style="margin: 0 auto ; text-align: center ">
          <el-button @click="closeDialog(3,'formMaintenancet')">关闭</el-button>
          <el-button type="primary" @click="saveMaintance('formMaintenancet')">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from "../../util/request";
import table2Excel from 'js-table2excel'; // 引入  js-table2excel
import * as XLSX from "xlsx" // 引入  xlsx
// import Template from "../template/Template";
import {ElLoading} from "element-plus";
// import axios from "axios";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Device',
  // components: {Template},
  data() {
    return {
      /**张 5.13*/
      dialogFormVisibleUnit: false,
      formUnit:{},
      dialogFormVisibleM: false,
      formMaintenancet:{},
      JugeByUnit:0,//使用单位是否重复，0不重复，1重复
      // JugeByUnitE:0,//使用单位是否重复，0不重复，1重复  修改
      JugeByMain:0,//使用单位是否重复，0不重复，1重复
      // JugeByMainE:0,//使用单位是否重复，0不重复，1重复  修改
      rulesAdd: {
        maintenance: [
          {required: true, min: 2, max: 50, validator: this.validateRepeatMain, trigger: 'blur'},
        ],
        unit: [
          {required: true, min: 2, max: 50, validator: this.validateRepeatUnit, trigger: 'blur'},
        ],
        createUnit: [{required: true, message: '请输入制造单位', trigger: 'blur'}],
        unitCode: [{required: true, message: '请输入使用单位代码', trigger: 'blur'}],
        unitArea: [{required: true, message: '请输入使用单位地址', trigger: 'blur'}],
      },


      search: '',
      superviseCode:'',
      // isupdate:false,//防止用户多次点击修改确定
      parentId: -1,
      areaList: [],
      areaList2: [],
      areaList3: [],
      areaList4: [],
      areaList5: [],
      areaParentIdOne: '',
      areaParentIdTwo: '',
      areaParentIdThree: '',
      areaParentIdFour: '',
      areaParentIdFive: '',
      form: {},
      editform: {},
      dialogFormVisibleEdit: false,
      dialogFormVisible: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      small: "small",
      background: "background",
      prev: this.currentPage - 1,
      pager: this.currentPage,
      next: this.currentPage + 1,
      jumper: this.currentPage,
      tableData: [],//设备列表
      reload: 0,//判断重新将currentPage 设置为 1； 0：currentPage=1
      varValue: "",//判断是否已经点击了模糊查询
      varValue1: "",//判断是否已经点击了模糊查询
      // saveIs:false,//判断是否已点击添加按钮
      rules: {
        unit: [
          // { pattern:/^([a-z0-9]([a-z0-9-.]*)[a-z0-9])$|^([a-z0-9])$/, message: '只能输入小写字母、数字、点号.和横线-并且点号 . 和横线 - 不能在开头或结尾', trigger: 'blur' },
          {required: true, min: 2, max: 50, message: '使用单位名不能为空,长度： 2 ~ 50', trigger: 'blur'},
          // {validator: validateSolution_Name, required: true, message: '方案名重复，重新输入', trigger: 'blur'}
        ],
        specialType: [
          {required: true, message: '请输入设备种类', trigger: 'blur'},
        ],
        // dateType: [
        //   {required: true, message: '请选择日期格式', trigger: 'blur'},
        // ],
        // preDateType: [
        //   {required: true, message: '请选择日期格式', trigger: 'blur'},
        // ],
        // createDateType: [
        //   {required: true, message: '请选择日期格式', trigger: 'blur'},
        // ],
        // updateDateType: [
        //   {required: true, message: '请选择日期格式', trigger: 'blur'},
        // ],
        // superviseDateType: [
        //   {required: true, message: '请选择日期格式', trigger: 'blur'},
        // ],
        // majorDateType: [
        //   {required: true, message: '请选择日期格式', trigger: 'blur'},
        // ],
        // nextDateType: [
        //   {required: true, message: '请选择日期格式', trigger: 'blur'},
        // ],
        // nextTestDateType: [
        //   {required: true, message: '请选择日期格式', trigger: 'blur'},
        // ],
        superviseCode: [{required: true, message: '请输入监察识别码', trigger: 'blur'}],
        // unitCode: [{required: true, message: '请输入使用单位代码', trigger: 'blur'}],
        // loginNum: [{required: true, message: '请输入使用登记证编号', trigger: 'blur'}],
        // unitNum: [{required: true, message: '请输入单位内编码', trigger: 'blur'}],
        // liftType: [{required: true, message: '请输入设备品种', trigger: 'blur'}],
        // liftModel: [{required: true, message: '请输入产品型号', trigger: 'blur'}],
        // liftNum: [{required: true, message: '请输入产品编号', trigger: 'blur'}],
        lifeKind: [{required: true, message: '请选择设备类别', trigger: 'blur'}],
        // lifeCode: [{required: true, message: '请输入设备代码', trigger: 'blur'}],
        createUnit: [{required: true, message: '请输入制造单位', trigger: 'blur'}],
        //   storey: [{required: true, message: '请输入层数', trigger: 'blur'}],
        //   lifeRegistCode: [{required: true, message: '请输入设备注册代码', trigger: 'blur'}],

        // createDate: [{required: true, message: '请输入制造时间', trigger: 'blur'}],
        // createStandard: [{required: true, message: '请输入', trigger: 'blur'}],
        maintenance: [{required: true, message: '请输入维护保养单位', trigger: 'blur'}],
        // createStandard2: [{required: true, message: '请输入使用单位地址', trigger: 'blur'}],
        // maxWeight: [{required: true, message: '请输入额定载重量', trigger: 'blur'}],
        // speed: [{required: true, message: '请输入额定速度', trigger: 'blur'}],
        //   storey: [{required: true, message: '请输入层数', trigger: 'blur'}],
        //   stand: [{required: true, message: '请输入站数', trigger: 'blur'}],
        //   door: [{required: true, message: '请输入门数', trigger: 'blur'}],
        // controller: [{required: true, message: '请输入控制方式', trigger: 'blur'}],
      },
      eqptypeList: [],//设备类别
      liftTypeList: [],//设备品种
      detailArea:'',//详细的地址
      count:0,//防止重复提交
      exportConfig: [ // 导出Excel表格配置
        {
          title: '使用单位名称',
          key: 'unit',
          type: 'text'
        },
        {
          title: '使用单位代码',
          key: 'unitCode',
          type: 'text'
        },
        {
          title: '使用登记证编号',
          key: 'loginNum',
          type: 'text'
        },
        {
          title: '使用设备地点',
          key: 'detailArea',
          type: 'text'
        },{
          title: '单位内编码',
          key: 'unitNum',
          type: 'text'
        },
        {
          title: '设备品种',
          key: 'liftType',
          type: 'text'
        },
        {
          title: '产品型号',
          key: 'liftModel',
          type: 'text'
        },
        {
          title: '产品编号',
          key: 'liftNum',
          type: 'text'
        },
        {
          title: '制造单位',
          key: 'createUnit',
          type: 'text'
        },
      ],
      importLiftkind:["曳引与强制驱动电梯","自动扶梯与自动人行道",
        "消防员电梯","防爆电梯","杂物电梯","斜行乘客与载货电梯","液压驱动电梯"],//导入设备类别用于对比
      importLiftTypeList: ["曳引驱动乘客电梯","曳引驱动载货电梯","强制驱动载货电梯","自动扶梯","自动人行道",
        "消防员电梯","防爆电梯","杂物电梯","斜行电梯","液压乘客电梯","液压载货电梯"],//导入设备品种用于对比
      exportImportConfig: [ // 导入Excel表格配置
        {
          title: '使用单位名称',
          key: 'unit',
          type: 'text'
        },
        {
          title: '使用单位代码',
          key: 'unitCode',
          type: 'text'
        },
        {
          title: '使用登记证编号',
          key: 'loginNum',
          type: 'text'
        },
        {
          title: '使用设备地点',
          key: 'detailArea',
          type: 'text'
        },
        {
          title: '单位内编码',
          key: 'unitNum',
          type: 'text'
        },
        {
          title: '设备品种',
          key: 'liftType',
          type: 'text'
        },
        {
          title: '产品型号',
          key: 'liftModel',
          type: 'text'
        },
        {
          title: '产品编号',
          key: 'liftNum',
          type: 'text'
        },
        {
          title: '制造单位',
          key: 'createUnit',
          type: 'text'
        },
        {
          title: '制造时间',
          key: 'createDate',
          type: 'text'
        },
        {
          title: '轿厢宽度',
          key: 'bridgeBoxWidth',
          type: 'text'
        },
        {
          title: '设备种类',
          key: 'specialType',
          type: 'text'
        },
        {
          title: '监察识别码',
          key: 'superviseCode',
          type: 'text'
        },
        {
          title: '设备类别',
          key: 'lifeKind',
          type: 'text'
        },
        {
          title: '维护保养单位',
          key: 'maintenance',
          type: 'text'
        },
        {
          title: '区域Id',
          key: 'areaId',
          type: 'text'
        },
        {
          title: '区域',
          key: 'areaName',
          type: 'text'
        },
        {
          title: '制造执行标准',
          key: 'createStandard',
          type: 'text'
        },
        {
          title: '改造单位',
          key: 'updateUnit',
          type: 'text'
        },{
          title: '改造时间',
          key: 'updateDate',
          type: 'text'
        },{
          title: '监督检验日期',
          key: 'superviseDate',
          type: 'text'
        },
        {
          title: '监督检测类型',
          key: 'superviseType',
          type: 'text'
        },
        {
          title: '使用登记机关',
          key: 'organ',
          type: 'text'
        },
        {
          title: '紧急救援电话',
          key: 'erpNum',
          type: 'text'
        },
        {
          title: '安全管理人员',
          key: 'safety',
          type: 'text'
        },
        {
          title: '安全管理人员电话',
          key: 'safetyNum',
          type: 'text'
        },
        {
          title: '重大修理单位',
          key: 'majorUnit',
          type: 'text'
        },
        {
          title: '施工单位',
          key: 'buildUnit',
          type: 'text'
        },
        {
          title: '重大修理时间',
          key: 'majorDate',
          type: 'text'
        },
        {
          title: '下次检测时间',
          key: 'nextDate',
          type: 'text'
        },
        {
          title: '下次检验时间',
          key: 'nextTestDate',
          type: 'text'
        },
        {
          title: '设备代码',
          key: 'lifeCode',
          type: 'text'
        },
        {
          title: '设备注册代码',
          key: 'lifeRegistCode',
          type: 'text'
        },
        {
          title: '电动机型号',
          key: 'electricModel',
          type: 'text'
        },
        {
          title: '桥厢尺寸深度',
          key: 'bridgeBoxDeep',
          type: 'text'
        },
        {
          title: '桥厢尺寸高度',
          key: 'bridgeBoxHigth',
          type: 'text'
        },
        {
          title: '额定压力',
          key: 'pressure',
          type: 'text'
        },
        {
          title: '额定速度',
          key: 'speed',
          type: 'text'
        },
        {
          title: '额定速度（上行）',
          key: 'speedUp',
          type: 'text'
        },
        {
          title: '额定速度（下行）',
          key: 'speedDown',
          type: 'text'
        },
        {
          title: '油缸数量',
          key: 'hcNum',
          type: 'text'
        },
        {
          title: '满载压力',
          key: 'maxPressure',
          type: 'text'
        },
        {
          title: '上端站',
          key: 'upStation',
          type: 'text'
        },
        {
          title: '下端站',
          key: 'downStation',
          type: 'text'
        },
        {
          title: '基站',
          key: 'baseStation',
          type: 'text'
        },
        {
          title: '悬挂装置规格',
          key: 'hangType',
          type: 'text'
        },
        {
          title: '悬挂装置数量',
          key: 'hangNum',
          type: 'text'
        },
        {
          title: '防爆等级',
          key: 'flameProof',
          type: 'text'
        },
        {
          title: '燃爆物质',
          key: 'material',
          type: 'text'
        },
        {
          title: '整机防爆标志',
          key: 'materialSign',
          type: 'text'
        },
        {
          title: '受检单位电话',
          key: 'testedNum',
          type: 'text'
        },
        {
          title: '缓冲器形式',
          key: 'bufferForm',
          type: 'text'
        },
        {
          title: '安全钳类型',
          key: 'safetyGear',
          type: 'text'
        },
        {
          title: '拖动方式',
          key: 'drag',
          type: 'text'
        },
        {
          title: '制动器形式',
          key: 'brakeForm',
          type: 'text'
        },
        {
          title: '悬挂装置',
          key: 'hang',
          type: 'text'
        },
        {
          title: '顶升形式',
          key: 'jacking',
          type: 'text'
        },
        {
          title: '开门形式',
          key: 'openForm',
          type: 'text'
        },
        {
          title: '额定载重量',
          key: 'maxWeight',
          type: 'text'
        },
        {
          title: '名义速度',
          key: 'nominalSpeed',
          type: 'text'
        },
        {
          title: '名义宽度',
          key: 'nominalWidth',
          type: 'text'
        },
        {
          title: '倾斜角',
          key: 'tilt',
          type: 'text'
        },
        {
          title: '输送能力',
          key: 'conveying',
          type: 'text'
        },
        {
          title: '提升高度',
          key: 'liftingHeight',
          type: 'text'
        },
        {
          title: '使用区段长度',
          key: 'section',
          type: 'text'
        },
        {
          title: '控制方式',
          key: 'controller',
          type: 'text'
        },
        {
          title: '驱动方式',
          key: 'driving',
          type: 'text'
        },
        {
          title: '机房形式',
          key: 'computer',
          type: 'text'
        },
        {
          title: '驱动主机布置',
          key: 'assign',
          type: 'text'
        },
        {
          title: '层',
          key: 'storey',
          type: 'text'
        },
        {
          title: '站',
          key: 'stand',
          type: 'text'
        },
        {
          title: '门',
          key: 'door',
          type: 'text'
        },
        {
          title: '轿门位置',
          key: 'doorPosition',
          type: 'text'
        },
        {
          title: '检验类别',
          key: 'testType',
          type: 'text'
        },
        {
          title: '设备所在区域',
          key: 'lifeArea',
          type: 'text'
        },
        {
          title: '楼盘名称',
          key: 'propertyName',
          type: 'text'
        },
        {
          title: '分支机构名称',
          key: 'branchName',
          type: 'text'
        },
        {
          title: '驱动主机型号',
          key: 'driveModel',
          type: 'text'
        },
        {
          title: '驱动主机编号',
          key: 'driveCode',
          type: 'text'
        },
        {
          title: '控制柜型号',
          key: 'controlBoxModel',
          type: 'text'
        },
        {
          title: '控制柜编号',
          key: 'controlBoxCode',
          type: 'text'
        },
        {
          title: '轿厢限速器型号',
          key: 'carModel',
          type: 'text'
        },
        {
          title: '轿厢限速器编号',
          key: 'carCode',
          type: 'text'
        },
        {
          title: '对重限速器型号',
          key: 'counterweightModel',
          type: 'text'
        },
        {
          title: '对重限速器编号',
          key: 'counterweightModelCode',
          type: 'text'
        },
        {
          title: '使用单位地址',
          key: 'unitArea',
          type: 'text'
        },
        {
          title: '分支机构地址',
          key: 'branchArea',
          type: 'text'
        },
        {
          title: '楼盘地址',
          key: 'propertyArea',
          type: 'text'
        },
        {
          title: '监督检验依据',
          key: 'proof',
          type: 'text'
        },
        {
          title: '上次检验日期',
          key: 'preDate',
          type: 'text'
        },
        {
          title: '上次检验日期格式',
          key: 'preDateType',
          type: 'text'
        },
        {
          title: '改造日期格式',
          key: 'updateDateType',
          type: 'text'
        },
        {
          title: '下次检测日期格式',
          key: 'nextDateType',
          type: 'text'
        },
        {
          title: '制造时间日期格式',
          key: 'createDateType',
          type: 'text'
        },
        {
          title: '监督检验日期格式',
          key: 'superviseDateType',
          type: 'text'
        },
        {
          title: '重大修理日期格式',
          key: 'majorDateType',
          type: 'text'
        },
        {
          title: '下次检验日期格式',
          key: 'nextTestDateType',
          type: 'text'
        },
      ],
    }
  },
  created() {
    this.load();
  },
  /**张 5.13*/
  mounted() {

  },

  methods: {
    /**张 5.13 使用单位输入框*/
      querySearch(queryString, cb) {
      console.log("开始判断。")
      console.log(queryString)
      if (queryString != "" && queryString.trim().length > 0){
        request.get('/Unit/getByUnit?unit=' + queryString.trim()).then(res => {
          // var results = queryString ? res.data.filter(this.createFilter(queryString)) : res.data;
          // 调用 callback 返回建议列表的数据
          console.log(res)
          cb(res.data);
        }).catch(error => {
          console.error(error);
          cb([]);
          this.form.propertyArea = "";
          this.form.propertyName = "";
          this.form.safety = "";
          this.form.safetyNum = "";
          this.form.testedNum = "";
          this.form.unitArea = "";
          this.form.unitCode = "";
        });
      }
    },
    /**
     * === 0  是从递一个字开始匹配，也就是模糊查询第一个字
     * > -1   是全字段模糊查询
     * */
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.unit.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
      };
    },

    handleSelect(item) {
      console.log(item);
      this.form.propertyArea = item.propertyArea;
      this.form.propertyName = item.propertyName;
      this.form.safety = item.safety;
      this.form.safetyNum = item.safetyNum;
      this.form.testedNum = item.testedNum;
      this.form.unitArea = item.unitArea;
      this.form.unitCode = item.unitCode;
    },
    handleSelectM(item){
      this.form.createUnit = item.createUnit;
      this.form.updateUnit = item.updateUnit;
      this.form.majorUnit = item.majorUnit;
      this.form.buildUnit = item.buildUnit;
      this.form.erpNum = item.erpNum;
      this.form.erpby = item.erpby;
    },
    /**维护保养单位输入框*/
    querySearchM(queryString, cb){

      if (queryString != "" && queryString.trim().length>0 ){
        request.get('/ProductionInfo/getByMaintenance?maintenance=' + queryString.trim()).then(res => {
          // 调用 callback 返回建议列表的数据
          console.log(res)
          cb(res.data);
        }).catch(error => {
          console.error(error);
          cb([]);
          this.form.createUnit = "";
          this.form.updateUnit = "";
          this.form.majorUnit = "";
          this.form.buildUnit = "";
          this.form.erpNum = "";
          this.form.erpby = "";
        });
      }
    },
    /**打开使用单位添加弹窗 （维保单位添加弹窗）*/
    addUnit(flag) {
      if (flag == 1){
        this.dialogFormVisibleUnit = true;
        this.formUnit = {};
      }else {
        this.dialogFormVisibleM = true;
        this.formMaintenancet= {};
      }

    },
    /**添加使用单位提交表单*/
    saveUnit(formName) {
      if (!this.validatorUnit()) {//验证不通过
        return false;
      }

      console.log(this.$refs[formName]);
      this.$confirm('是否提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.count++;
        if (this.count >= 2) {
          this.$message({
            message: "正在处理...",
            type: "warning"
          });
          return
        }
        request.post('/Unit/save', this.formUnit).then(res => {
          this.count=0;
          console.log(res.code + res.mag + res.date + "save" + res);
          if (res.code === "0") {
            this.$message({
              message: "添加成功",
              type: "success"
            });
            // this.load(1);
            this.dialogFormVisibleUnit = false;
          }else {
            this.$message({
              message: "添加失败",
              type: "error"
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });

    },
    /**添加使用单位提交表单*/
    saveMaintance(formName) {
      if (!this.validatorMain()) {//验证不通过
        return false;
      }

      console.log(this.$refs[formName]);
      this.$confirm('是否提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.count++;
        if (this.count >= 2) {
          this.$message({
            message: "正在处理...",
            type: "warning"
          });
          return
        }
        request.post('/ProductionInfo/save', this.formMaintenancet).then(res => {
          this.count=0;
          console.log(res.code + res.mag + res.date + "save" + res);
          if (res.code === "0") {
            this.$message({
              message: "添加成功",
              type: "success"
            });
            // this.load(1);
            this.dialogFormVisibleM = false;
          }else {
            this.$message({
              message: "添加失败",
              type: "error"
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });

    },
    //验证使用单位名称是否重复
    validateRepeatUnit(rule, value, callback){
      if (!value) {
        callback(new Error('请选择或添加'))
      } else {
        request.get('/Unit/JugeByUnit?unit='+ value.trim()).then(res => {
          const data = res.data.flag
          this.JugeByUnit = res.data.flag
          if (data === 0){
            callback()
          }else {
            callback(new Error('该维保单位名称已存在'))
          }
        })
      }
    },
    //表单验证 使用单位添加
    validatorUnit(){
      if (this.dialogFormVisibleUnit){//添加
        if (this.formUnit.unit === '' || this.formUnit.unit === null || this.formUnit.unit === undefined) {
          this.$message({
            message: "请填写使用单位名称",
            type: "warning"
          });
          return false;
        }
        if (this.JugeByUnit === 1 ) {
          this.$message({
            message: "使用单位名称重复",
            type: "warning"
          });
          return false;
        }
        if (this.formUnit.unitArea === '' || this.formUnit.unitArea === null || this.formUnit.unitArea === undefined) {
          this.$message({
            message: "请填写使用单位地址",
            type: "warning"
          });
          return false;
        }
        if (this.formUnit.unitCode === '' || this.formUnit.unitCode === null || this.formUnit.unitCode === undefined) {
          this.$message({
            message: "请填写使用单位代码",
            type: "warning"
          });
          return false;
        }
      }
      return true;
    },
    //维保单位验证是否重复
    validateRepeatMain(rule, value, callback){
      if (!value) {
        callback(new Error('请选择或添加'))
      } else {
        request.get('/ProductionInfo/JugeMaintenance?maintenance='+ value.trim()).then(res => {
          const data = res.data.flag
          this.JugeByMain = res.data.flag
          if (data === 0){
            callback()
          }else {
            callback(new Error('该维保单位名称已存在'))
          }
        })
      }
    },
    //维保单位表单验证
    validatorMain(){
      if (this.dialogFormVisibleM){//添加
        if (this.formMaintenancet.maintenance === '' || this.formMaintenancet.maintenance === null || this.formMaintenancet.maintenance === undefined) {
          this.$message({
            message: "请填写维保单位名称",
            type: "warning"
          });
          return false;
        }
        if (this.JugeByMain === 1 ) {
          this.$message({
            message: "维保单位名称重复",
            type: "warning"
          });
          return false;
        }
        // if (this.formMaintenancet.createUnit === '' || this.formMaintenancet.createUnit === null || this.formMaintenancet.createUnit === undefined) {
        //   this.$message({
        //     message: "请填写制造单位",
        //     type: "warning"
        //   });
        //   return false;
        // }
      }
      return true;
    },





    //导出数据
    exportDate(){
      const loading = ElLoading.service({ // 打开遮罩层
        lock: true,
        text: '请稍等...',
        background: 'rgba(255, 255, 255, 0.5)',
      })

      let map = {
        "page": this.currentPage,
        "size": this.pageSize,
        "unit": this.search,
        "sign":'1'//用于判断是否查询所有
      };
      request.post('/Device/deviceAll', map).then(res => {
        console.log(res);
        if (res.code === "0") {
          let table = res.data.deviceList;
          let arr =JSON.parse(JSON.stringify(table)) ;
          // let arr =JSON.parse(JSON.stringify(this.tableData)) ;
          console.log(arr)
          let date = this.formatDate(new Date(), "yyyy-MM-dd");
          table2Excel(this.exportConfig, arr, '设备导出数据_'+date)
          // table2Excel(this.exportImportConfig, arr, '设备导出数据_'+date)
          loading.close() // 关闭遮罩层
        } else {
          this.$message({
            message: "导出数据失败",
            type: "error"
          });
          loading.close() // 关闭遮罩层
        }
      })
    },
    // 表格导入
    importBefore(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        // console.log(data)
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const results = XLSX.utils.sheet_to_json(worksheet);
        // this.importAdd(results)
        this.getArea(results)
      };
      reader.readAsArrayBuffer(file);
    },

    importAdd(list,areas,vDeviceArea,loading) {
      let areasError = [];//区域报错的行
      let maintenanceError = [];//维护保养单位报错的行
      let unitError = [];//使用单位报错的行
      let superviseCodeError = [];//监察识别码报错的行
      let lifeKindError = [];//设备类别报错的行
      let detailAreaError = [];//详细地址报错的行
      // 处理上传时excel中特殊字段
      // 如：性别：男/女 不能以文字形式上传，此方法时将数据转为对应的值
      list.forEach((item,index) => {
        // this.exportConfig.forEach((i) => {
        this.exportImportConfig.forEach((i) => {
          // console.log(item[i.title]+"-.trim()--"+i.title.length)
          // if(item[i.title]!=null && item[i.title]!==""&& item[i.title]!=undefined&& item[i.title]!="null"){
          item[i.key] = item[i.title]
          delete item[i.title]
          // }

        })
        // 处理时间，在使用FileReader解析后的时间可能是这样的 44877.4284259259 就需要专为时间戳或者时间格式
        for (let key in item) {

          areas.forEach((obj) => {
            if(item["areaName"]==""|| item["areaName"] ===undefined||item["areaName"] =="null"){
              if( !areasError.includes(index+1)){
                areasError.push(index+1)
              }
            }else {//根据所在区域选择对应的区域Id
              if(obj.areaName === item["areaName"].trim()){
                item["areaId"]=obj.areaId;
                // console.log("==== item[\"areaId\"]=="+ item["areaId"])
              }
            }
          })
          //默认为电梯类型
          if (key == "specialType") {
            item[key]=1;
          }
          if (key == "unit") {
            if(item[key]==" "||item[key]==""|| item[key] ===undefined||item[key] =="null"){
              console.log("---------unit-------"+item[key])
              if( !unitError.includes(index+1)){
                unitError.push(index+1)
                // console.log("---------unit--11-----")
              }
            }
          }
          if (key == "superviseCode") {
            if(item[key]==" "||item[key]==""|| item[key] ===undefined||item[key] =="null"){
              if( !superviseCodeError.includes(index+1)){
                superviseCodeError.push(index+1)
              }
            }
          }
          if (key == "lifeKind") {
            if(item[key]==" "||item[key]==""|| item[key] ===undefined||item[key] =="null"){
              if( !lifeKindError.includes(index+1)){
                lifeKindError.push(index+1)
              }
            }
          }
          if (key == "detailArea") {
            if(item[key]==" "||item[key]==""|| item[key] ===undefined||item[key] =="null"){
              if( !detailAreaError.includes(index+1)){
                detailAreaError.push(index+1)
              }
            }
          }
          if (key == "maintenance") {
            if(item[key]==" "||item[key]==""|| item[key] ===undefined||item[key] =="null"){
              if( !maintenanceError.includes(index+1)){
                maintenanceError.push(index+1)
              }
            }
          }
          //处理时间格式
          if (key == "createDate"|| key == "updateDate"||key == "superviseDate"||key == "majorDate"||key == "nextDate"||key == "nextTestDate"||key == "preDate") {
            if(item[key]!==""&&item[key]!==undefined&&item[key]!=="null"){
              item[key] =this.ExcelDateToJSDate(item[key]);
              item[key] =this.formatDate(item[key],"yyyy-MM-dd");
              if(item[key]==="NaN-aN-aN"){
                this.$message({
                  message: "时间格式出错，出错行有："+(index+1),
                  type: "error"
                });
                loading.close() // 关闭遮罩层
                return ;
              }
              // if(item[key].length>7) {
              //   item[key] = item[key].substring(0, 10);
              // }else if(item[key].length>5) {
              //   item[key] = item[key].substring(0, 8)+"-10";
              // }else if(item[key].length>3) {
              //   item[key] = item[key].substring(0, 5)+"-10-10";
              // }
            }
          }
          if ( item[key]===undefined || item[key]==="null"){
            item[key]="";//防止不填信息报错
          }
          if(item[key]!=null&&item[key]!==""&&item[key]!=undefined&&item[key]!="null"){
            item[key] = item[key].toString().trim();//去除前后空格
          }
        }
      })
      if(areasError!=null && areasError.length>0){
        this.$message({
          message: "区域名称出错，区域名称不能为空(或区域名称标题存在空格)，出错行有："+areasError,
          type: "error"
        });
        loading.close() // 关闭遮罩层
        return ;
      }
      if(unitError!=null && unitError.length>0){
        this.$message({
          message: "使用单位出错,使用单位不能为空(或使用单位标题存在空格)，出错行有："+unitError,
          type: "error"
        });
        loading.close() // 关闭遮罩层
        return ;
      }
      if(superviseCodeError!=null && superviseCodeError.length>0){
        this.$message({
          message: "监察识别码出错，监察识别码不能为空(或监察识别码标题存在空格)，出错行有："+superviseCodeError,
          type: "error"
        });
        loading.close() // 关闭遮罩层
        return ;
      }
      if(lifeKindError!=null && lifeKindError.length>0){
        this.$message({
          message: "设备类别出错，设备类别不能为空(或设备类别标题存在空格)，出错行有："+lifeKindError,
          type: "error"
        });
        loading.close() // 关闭遮罩层
        return ;
      }
      if(detailAreaError!=null && detailAreaError.length>0){
        this.$message({
          message: "详细地址出错，详细地址不能为空(或详细地址标题存在空格)，出错行有："+detailAreaError,
          type: "error"
        });
        loading.close() // 关闭遮罩层
        return ;
      }
      if(maintenanceError!=null && maintenanceError.length>0){
        this.$message({
          message: "维护保养单位出错，维护保养单位不能为空(或维护保养单位标题存在空格)，出错行有："+maintenanceError,
          type: "error"
        });
        loading.close() // 关闭遮罩层
        return ;
      }

      let liftkinds = [];
      let liftkindlist = list.filter((e,i) => {
        if(e.lifeKind!=null && e.lifeKind!==""&& e.lifeKind!=undefined&&e.lifeKind!="null"){
          if (!this.importLiftkind.includes(e.lifeKind.trim())){
            liftkinds.push(i+1);
          }
          return !this.importLiftkind.includes(e.lifeKind.trim());
        }
      });
      if(liftkindlist!=null && liftkindlist.length>0){
        this.$message({
          message: "设备类别出错，设备类别未识别(或设备类别标题存在空格)，出错行有："+liftkinds,
          type: "error"
        });
        loading.close() // 关闭遮罩层
        return ;
      }
      let liftTypes = [];
      let liftTypelist = list.filter((e,i) => {
        if(e.liftType!=null && e.liftType!==""&& e.liftType!=undefined&&e.liftType!="null"){
          if (!this.importLiftTypeList.includes(e.liftType.trim())){
            liftTypes.push(i+1);
          }
          return !this.importLiftTypeList.includes(e.liftType.trim());
        }
      });
      if(liftTypelist!=null && liftTypelist.length>0){
        this.$message({
          message: "设备种类出错，设备种类未识别(或设备种类标题存在空格)，出错行有："+liftTypes,
          type: "error"
        });
        loading.close() // 关闭遮罩层
        return ;
      }

      let ids = areas.map(e => e.areaName);
      let index = [];
      let orders = list.filter((e,i) => {
        if(e.areaName!=null && e.areaName!==""&&e.areaName!=undefined&&e.areaName!="null"){
          if (!ids.includes(e.areaName.trim())){
            index.push(i+1);
          }
          return !ids.includes(e.areaName.trim());
        }
      });
      //对比区域名称是否未添加
      if(orders!=null && orders.length>0){
        this.$message({
          message: "区域名称出错，区域未添加，出错行有："+index,
          type: "error"
        });
        loading.close() // 关闭遮罩层
        return ;
      }
      //对比监察识别码是否重复
      let superviseCodes = vDeviceArea.map(e => e.superviseCode);
      let a=[];
      let lists = list.filter((e,i) => {
        if(superviseCodes.includes(e.superviseCode.trim())){
          a.push(i+1)
        }
        return superviseCodes.includes(e.superviseCode.trim())
      });
      if(lists!=null && lists.length>0){
        this.$message({
          message: "监察识别码重复了，出错行有："+a,
          type: "error"
        });
        loading.close() // 关闭遮罩层
        return ;
      }
      list = this.convertImportData(list);
      // list 返回上传的Excel文件，接下来掉后台接口批量添加就可以了。
      console.log(list)
      // loading.close() // 关闭遮罩层
      request.post('/Device/importDeviceAll', list).then(res => {
        console.log(res);
        if (res.code === "0") {
      this.$message({
            message: "导入数据成功",
            type: "success"
          })
      loading.close() // 关闭遮罩层
           this.load();
        } else {
          this.$message({
            message: "导入数据失败",
            type: "error"
          })
      loading.close() // 关闭遮罩层
        }
      })
    },
    getDate(strDate) {
      var date = eval('new Date(' + strDate.replace(/\d+(?=-[^-]+$)/,
              function (a) { return parseInt(a, 10) - 1; }).match(/\d+/g) + ')');
      return date;
    },
    getArea(list){
      const loading = ElLoading.service({ // 打开遮罩层
        lock: true,
        text: '请稍等...',
        background: 'rgba(255, 255, 255, 0.5)',
      })
      let map = {
        "page": this.currentPage,
        "size": this.pageSize,
        "unit": this.search,
        "sign":'1'//用于判断是否查询所有
      };
      request.post('/Device/getArea', map).then(res => {
        if (res.code === "0") {
          // console.log( res.data);
          this.importAdd(list,res.data.areas,res.data.vDeviceArea,loading)
        } else {
          this.$message({
            message: "查询区域失败",
            type: "error"
          });
          loading.close() // 关闭遮罩层
        }
      })
    }, //查询区域信息和设备信息
    convertImportData(list) {
      list.forEach((item) => {
        // this.formatColumns.forEach((i) => {
        //   for (let key in i.option) {
        //     if (item[i.prop] == i.option[key]) {
        //       item[i.prop] = key
        //     }
        //   }
        // })
        for (let key in item) {
          if (!item[key] && item[key] == undefined ) {
            item[key] = ""
          }
        }
      });
      return list
    },
    ExcelDateToJSDate(serial) {
      var utc_days = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);
      var fractional_day = serial - Math.floor(serial) + 0.0000001;
      var total_seconds = Math.floor(86400 * fractional_day);
      var seconds = total_seconds % 60;
      total_seconds -= seconds;
      var hours = Math.floor(total_seconds / (60 * 60));
      var minutes = Math.floor(total_seconds / 60) % 60;
      return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
    } ,
    refresh() {//刷新
      this.search = '';
      this.superviseCode='';
      this.load(0);
    },
    qSearch() {
      this.load(0);
      this.varValue = this.search;
      this.varValue1 = this.superviseCode;
    },
    closeDialog(tag, formName) {
      if (tag === 0) {
        this.dialogFormVisible = false;
        this.form = {};
        this.$refs[formName].resetFields();
      } else if (tag === 1) {
        this.dialogFormVisibleEdit = false;
        this.editform = {};
        this.$refs[formName].resetFields();
      } else if (tag ===2) {
        this.dialogFormVisibleUnit = false;
        this.formUnit = {};
        this.$refs[formName].resetFields();
      }else {
        this.dialogFormVisibleM= false;
        this.formMaintenancet = {};
        this.$refs[formName].resetFields();
      }
    },
    //添加按钮点击事件
    add() {
      this.dialogFormVisible = true;
      this.form = {};
      this.areaParentIdOne = "";
      this.queryAreaList(this.parentId);
      // this.getEqpType();
    },
    getDateType() {//选择日期格式
    },
    // dateType(dateType, date) {//
    //   if (dateType === '年月日') {
    //     date = this.formatDate(date, "yyyy年MM月dd日")
    //   } else if (dateType === '年月') {
    //     date = this.formatDate(date, "yyyy年MM月")
    //   } else {
    //     date = this.formatDate(date, "yyyy年")
    //   }
    //   return date;
    // },
    // dateShow(dateType,date){
    //   if (dateType === '年月日') {
    //     date = this.formatDate(date, "yyyy-MM-dd")
    //   } else if (dateType === '年月') {
    //     date = this.formatDate(date, "yyyy-MM")
    //   } else {
    //     date = this.formatDate(date, "yyyy")
    //   }
    //   return date;
    // },
    getEqpType(EqpType, id) {//查询设备类别
      console.log(EqpType, id);
      this.eqptypeList = [];
      this.form.liftType = '';
      this.form.lifeKind = '';
      request.post('/Device/getEqpType', EqpType).then(res => {
        console.log(res.code + res.mag + res.data + "getEqpType" + res);
        if (res.code === "0") {
          this.eqptypeList = res.data;
          // if(id===1){//修改
          //     this.
          // }
        } else {
          this.$message({
            message: "查询设备类别失败",
            type: "error"
          });

        }
      })
    },
    getliftType(lifeKind, id) {//查询设备品种
      console.log(lifeKind);

      this.liftTypeList = [];
      request.get('/Device/getliftType?lifeKind=' + lifeKind).then(res => {
        console.log(res.code + res.mag + res.data + "getliftType" + res);
        if (res.code === "0") {
          this.liftTypeList = res.data;
          if (id === 0) {
            this.form.liftType = '';
          } else {
            for (let i = 0; i < this.liftTypeList.length; i++) {
              if (this.liftTypeList.find(e => e.liftType === this.editform.liftType)) {
                // console.log("222")
              } else this.editform.liftType = '';
            }
          }
        } else {
          this.$message({
            message: "查询设备品种失败",
            type: "error"
          });
          this.editform.liftType = '';
          this.form.liftType = '';
        }
      })
    },
    //时间格式
    formatDate(value, fmt) {
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt;
    },
    //页面初始化
    load(reload) {
      if ((this.search !== ''||this.superviseCode !== '' )&& this.currentPage !== 1) {
        if (this.reload === reload) {
          this.currentPage = 1;
        }
      }
      let map = {
        "page": this.currentPage,
        "size": this.pageSize,
        "unit": this.search,
        "superviseCode": this.superviseCode
        // "sign":sign//用于判断是否查询所有
      };
      request.post('/Device/deviceAll', map).then(res => {
        console.log(res);
        if (res.code === "0") {
          this.tableData = res.data.deviceList;
          this.total = res.data.total
        } else {
          this.tableData = [];
          this.total = 0;
        }
      })
    },

    validator() {//表单验证
      if (this.dialogFormVisibleEdit) {//修改
        if (this.editform.specialType === '' || this.editform.specialType === null || this.editform.specialType === undefined) {
          this.$message({
            message: "请选择设备种类",
            type: "warning"
          });
          return false;
        }
        if (this.editform.detailArea === '' || this.editform.detailArea === null || this.editform.detailArea === undefined) {
          this.$message({
            message: "请选择具体地址",
            type: "warning"
          });
          return false;
        }else this.editform.detailArea = this.editform.detailArea.toString().trim();
        // if (this.editform.lifeRegistCode === ''||this.editform.lifeRegistCode === null || this.editform.lifeRegistCode === undefined) {
        //     this.$message({
        //         message: "请输入设备注册代码",
        //         type: "warning"
        //     });
        //     return false;
        // }
        if (this.editform.unit === '' || this.editform.unit === null || this.editform.unit === undefined) {
          this.$message({
            message: "请输入使用单位名称",
            type: "warning"
          });
          return false;
        }else this.editform.unit = this.editform.unit.toString().trim();
        // if (this.editform.unitCode === '' || this.editform.unitCode === null || this.editform.unitCode === undefined) {
        //   this.$message({
        //     message: "请输入使用单位代码",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.editform.loginNum === '' || this.editform.loginNum === null || this.editform.loginNum === undefined) {
        //   this.$message({
        //     message: "请输入使用登记证编号",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.editform.unitNum === '' || this.editform.unitNum === null || this.editform.unitNum === undefined) {
        //   this.$message({
        //     message: "请输入单位内编码",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.editform.lifeCode === '' || this.editform.lifeCode === null || this.editform.lifeCode === undefined) {
        //   this.$message({
        //     message: "请输入设备代码",
        //     type: "warning"
        //   });
        //   return false;
        // }
        if (this.editform.lifeKind === '' || this.editform.lifeKind === null || this.editform.lifeKind === undefined) {
          this.$message({
            message: "请输入设备类别",
            type: "warning"
          });
          return false;
        }else this.editform.lifeKind = this.editform.lifeKind.toString().trim();
        // if (this.editform.liftType === '' || this.editform.liftType === null || this.editform.liftType === undefined) {
        //   this.$message({
        //     message: "请输入设备品种",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.editform.liftModel === '' || this.editform.liftModel === null || this.editform.liftModel === undefined) {
        //   this.$message({
        //     message: "请输入产品型号",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.editform.liftNum === '' || this.editform.liftNum === null || this.editform.liftNum === undefined) {
        //   this.$message({
        //     message: "请输入产品编号",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.editform.createUnit === '' || this.editform.createUnit === null || this.editform.createUnit === undefined) {
        //   this.$message({
        //     message: "请输入制造单位",
        //     type: "warning"
        //   });
        //   return false;
        // }

        if (this.editform.specialType === 1) {//选择电梯
          if (this.editform.superviseCode === '' || this.editform.superviseCode === null || this.editform.superviseCode === undefined) {
            this.$message({
              message: "请输入监察识别码",
              type: "warning"
            });
            return false;
          }else {
            this.editform.superviseCode = this.editform.superviseCode.toString().trim();

          }
          // if (this.editform.storey === ''||this.editform.storey === null || this.editform.storey === undefined) {
          //     this.$message({
          //         message: "请输入层数",
          //         type: "warning"
          //     });
          //     return false;
          // }
          // if (this.editform.createDate === '' || this.editform.createDate === null || this.editform.createDate === undefined) {
          //   this.$message({
          //     message: "请输入制造时间",
          //     type: "warning"
          //   });
          //   return false;
          // }
          // if (this.editform.createStandard === '' || this.editform.createStandard === null || this.editform.createStandard === undefined) {
          //   this.$message({
          //     message: "请输入制造执行标准",
          //     type: "warning"
          //   });
          //   return false;
          // }
          if (this.editform.maintenance === '' || this.editform.maintenance === null || this.editform.maintenance === undefined) {
            this.$message({
              message: "请输入维护保养单位",
              type: "warning"
            });
            return false;
          }else this.editform.maintenance = this.editform.maintenance.toString().trim();
        } else {//起重机的修改
          // if (this.editform.createStandard === '' || this.editform.createStandard === null || this.editform.createStandard === undefined) {
          //   this.$message({
          //     message: "请输入使用单位地址",
          //     type: "warning"
          //   });
          //   return false;
          // }

          // if (this.editform.createDate === '' || this.editform.createDate === null || this.editform.createDate === undefined) {
          //   this.$message({
          //     message: "请输入投入使用日期",
          //     type: "warning"
          //   });
          //   return false;
          // }

          if (this.editform.maintenance === '' || this.editform.maintenance === null || this.editform.maintenance === undefined) {
            this.$message({
              message: "请输入使用单位邮政编码",
              type: "warning"
            });
            return false;
          }else this.editform.maintenance = this.editform.maintenance.toString().trim();
        }
      }
      if (this.dialogFormVisible) {//添加
        if (this.form.specialType === '' || this.form.specialType === null || this.form.specialType === undefined) {
          this.$message({
            message: "请选择设备种类",
            type: "warning"
          });
          return false;
        }
        // if (this.form.lifeRegistCode === ''||this.form.lifeRegistCode === null || this.form.lifeRegistCode === undefined) {
        //     this.$message({
        //         message: "请输入设备注册代码",
        //         type: "warning"
        //     });
        //     return false;
        // }

        if (this.form.unit === '' || this.form.unit === null || this.form.unit === undefined) {
          this.$message({
            message: "请输入使用单位名称",
            type: "warning"
          });
          return false;
        }else this.form.unit = this.form.unit.toString().trim();
        // if (this.form.unitCode === '' || this.form.unitCode === null || this.form.unitCode === undefined) {
        //   this.$message({
        //     message: "请输入使用单位代码",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.form.loginNum === '' || this.form.loginNum === null || this.form.loginNum === undefined) {
        //   this.$message({
        //     message: "请输入使用登记证编号",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.form.unitNum === '' || this.form.unitNum === null || this.form.unitNum === undefined) {
        //   this.$message({
        //     message: "请输入单位内编码",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.form.lifeCode === '' || this.form.lifeCode === null || this.form.lifeCode === undefined) {
        //   this.$message({
        //     message: "请输入设备代码",
        //     type: "warning"
        //   });
        //   return false;
        // }
        if (this.form.lifeKind === '' || this.form.lifeKind === null || this.form.lifeKind === undefined) {
          this.$message({
            message: "请输入设备类别",
            type: "warning"
          });
          return false;
        }else this.form.lifeKind = this.form.lifeKind.toString().trim();
        if (this.form.detailArea === '' || this.form.detailArea === null || this.form.detailArea === undefined) {
          this.$message({
            message: "请选择具体地址",
            type: "warning"
          });
          return false;
        }else this.form.detailArea = this.form.detailArea.toString().trim();
        // if (this.form.liftType === '' || this.form.liftType === null || this.form.liftType === undefined) {
        //   this.$message({
        //     message: "请输入设备品种",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.form.liftModel === '' || this.form.liftModel === null || this.form.liftModel === undefined) {
        //   this.$message({
        //     message: "请输入产品型号",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.form.liftNum === '' || this.form.liftNum === null || this.form.liftNum === undefined) {
        //   this.$message({
        //     message: "请输入产品编号",
        //     type: "warning"
        //   });
        //   return false;
        // }
        // if (this.form.createUnit === '' || this.form.createUnit === null || this.form.createUnit === undefined) {
        //   this.$message({
        //     message: "请输入制造单位",
        //     type: "warning"
        //   });
        //   return false;
        // }
        if (this.form.specialType === 1) {//选择了电梯
          if (this.form.superviseCode === '' || this.form.superviseCode === null || this.form.superviseCode === undefined) {
            this.$message({
              message: "请输入监察识别码",
              type: "warning"
            });
            return false;
          }else{
            this.form.superviseCode = this.form.superviseCode.toString().trim();
          }
          // if (this.form.storey === ''||this.form.storey === null || this.form.storey === undefined) {
          //     this.$message({
          //         message: "请输入层数",
          //         type: "warning"
          //     });
          //     return false;
          // }
          // if (this.form.createDate === '' || this.form.createDate === null || this.form.createDate === undefined) {
          //   this.$message({
          //     message: "请输入制造时间",
          //     type: "warning"
          //   });
          //   return false;
          // }
          // if (this.form.createStandard === '' || this.form.createStandard === null || this.form.createStandard === undefined) {
          //   this.$message({
          //     message: "请输入制造执行标准",
          //     type: "warning"
          //   });
          //   return false;
          // }
          if (this.form.maintenance === '' || this.form.maintenance === null || this.form.maintenance === undefined) {
            this.$message({
              message: "请输入维护保养单位",
              type: "warning"
            });
            return false;
          }else this.form.maintenance = this.form.maintenance.toString().trim();
        } else {//选择了起重机
          // console.log("1111------")
          // if (this.form.createStandard === '' || this.form.createStandard === null || this.form.createStandard === undefined) {
          //   this.$message({
          //     message: "请输入使用单位地址",
          //     type: "warning"
          //   });
          //   return false;
          // }
          // if (this.form.createDate === '' || this.form.createDate === null || this.form.createDate === undefined) {
          //   this.$message({
          //     message: "请输入投入使用日期",
          //     type: "warning"
          //   });
          //   return false;
          // }
          if (this.form.maintenance === '' || this.form.maintenance === null || this.form.maintenance === undefined) {
            this.$message({
              message: "请输入使用单位邮政编码",
              type: "warning"
            });
            return false;
          }else this.form.maintenance = this.form.maintenance.toString().trim();

        }

      }
      // if (this.areaParentIdFive === '' || this.areaParentIdFive === null || this.areaParentIdFive === undefined) {
      //   this.$message({
      //     message: "请选择具体地址",
      //     type: "warning"
      //   });
      //   return false;
      // }
      if (this.areaParentIdThree === '' || this.areaParentIdThree === null || this.areaParentIdThree === undefined) {
        this.$message({
          message: "请选择区或镇",
          type: "warning"
        });
        return false;
      }
      return true;
    },
    //保持数据
    save(formName) {
      // this.validator();
      if (!this.validator()) {//验证不通过
        return false;
      }

      console.log(this.$refs[formName]);
      // this.$refs[formName].validate((valid) => {
      //valid是检验的结果,bool值 validator: validateSolution_Name,
      // if (valid) {
      //     this.saveIs =true;
      // this.form.areaId = this.areaList5[this.areaParentIdFive].areaId;
      this.form.areaId = this.areaList3[this.areaParentIdThree].areaId;
      let device = null;
      if (this.form.specialType === 1) {
        device = {
          // liftId :this.form.liftId,
          areaId: this.form.areaId,
          unit: this.form.unit,
          // dateType: this.form.dateType,
          unitCode: this.form.unitCode,
          loginNum: this.form.loginNum,
          unitNum: this.form.unitNum,
          liftType: this.form.liftType,
          liftModel: this.form.liftModel,
          liftNum: this.form.liftNum,
          createUnit: this.form.createUnit,
          createDate: this.form.createDate,
          createStandard: this.form.createStandard,
          updateUnit: this.form.updateUnit,
          updateDate: this.form.updateDate,
          maintenance: this.form.maintenance,
          superviseDate: this.form.superviseDate,
          superviseType: this.form.superviseType,
          organ: this.form.organ,
          erpNum: this.form.erpNum,
          safety: this.form.safety,
          safetyNum: this.form.safetyNum,
          majorUnit: this.form.majorUnit,
          buildUnit: this.form.buildUnit,
          majorDate: this.form.majorDate,
          nextDate: this.form.nextDate,
          nextTestDate: this.form.nextTestDate,
          lifeCode: this.form.lifeCode,
          lifeRegistCode: this.form.lifeRegistCode,
          lifeKind: this.form.lifeKind,
          electricModel: this.form.electricModel,
          bridgeBoxWidth: this.form.bridgeBoxWidth,
          bridgeBoxDeep: this.form.bridgeBoxDeep,
          bridgeBoxHigth: this.form.bridgeBoxHigth,
          pressure: this.form.pressure,
          speed: this.form.speed,
          speedUp: this.form.speedUp,
          speedDown: this.form.speedDown,
          hcNum: this.form.hcNum,
          maxPressure: this.form.maxPressure,
          upStation: this.form.upStation,
          downStation: this.form.downStation,
          baseStation: this.form.baseStation,
          hangType: this.form.hangType,
          hangNum: this.form.hangNum,
          flameProof: this.form.flameProof,
          material: this.form.material,
          materialSign: this.form.materialSign,
          testedNum: this.form.testedNum,
          bufferForm: this.form.bufferForm,
          safetyGear: this.form.safetyGear,
          drag: this.form.drag,
          brakeForm: this.form.brakeForm,
          hang: this.form.hang,
          jacking: this.form.jacking,
          openForm: this.form.openForm,
          maxWeight: this.form.maxWeight,
          nominalSpeed: this.form.nominalSpeed,
          nominalWidth: this.form.nominalWidth,
          tilt: this.form.tilt,
          conveying: this.form.conveying,
          liftingHeight: this.form.liftingHeight,
          section: this.form.section,
          controller: this.form.controller,
          driving: this.form.driving,
          computer: this.form.computer,
          assign: this.form.assign,
          storey: this.form.storey,
          stand: this.form.stand,
          door: this.form.door,
          doorPosition: this.form.doorPosition,
          testType: '',
          specialType: this.form.specialType,
          superviseCode: this.form.superviseCode,
          lifeArea: this.form.lifeArea,
          propertyName: this.form.propertyName,
          branchName: this.form.branchName,
          driveModel: this.form.driveModel,
          driveCode: this.form.driveCode,
          controlBoxModel: this.form.controlBoxModel,
          controlBoxCode: this.form.controlBoxCode,
          carModel: this.form.carModel,
          carCode: this.form.carCode,
          counterweightModel: this.form.counterweightModel,
          counterweightModelCode: this.form.counterweightModelCode,
          unitArea: this.form.unitArea,
          branchArea: this.form.branchArea,
          propertyArea: this.form.propertyArea,
          proof: this.form.proof,
          preDate :this.form.preDate,
          preDateType: this.form.preDateType,
          updateDateType: this.form.updateDateType,
          nextDateType: this.form.nextDateType,
          createDateType: this.form.createDateType,
          superviseDateType: this.form.superviseDateType,
          majorDateType: this.form.majorDateType,
          nextTestDateType: this.form.nextTestDateType,
          detailArea: this.form.detailArea,
        };
      } else {
        device = {
          // liftId :this.form.liftId,
          areaId: this.form.areaId,
          // dateType: this.form.dateType,
          unit: this.form.unit,
          unitCode: this.form.unitCode,
          loginNum: this.form.loginNum,
          unitNum: this.form.unitNum,
          liftType: this.form.liftType,
          liftModel: this.form.liftModel,
          liftNum: this.form.liftNum,
          createUnit: this.form.createUnit,
          createDate: this.form.createDate,
          createStandard: this.form.createStandard,
          updateUnit: this.form.updateUnit,
          updateDate: this.form.updateDate,
          maintenance: this.form.maintenance,
          superviseDate: this.form.superviseDate,
          superviseType: this.form.superviseType,
          organ: this.form.organ,
          erpNum: this.form.erpNum,
          safety: this.form.safety,
          safetyNum: this.form.safetyNum,
          majorUnit: this.form.majorUnit,
          buildUnit: this.form.buildUnit,
          majorDate: this.form.majorDate,
          nextDate: this.form.nextDate,
          nextTestDate: this.form.nextTestDate,
          lifeCode: this.form.lifeCode,
          lifeRegistCode: this.form.lifeRegistCode,
          lifeKind: this.form.lifeKind,
          electricModel: this.form.electricModel,
          bridgeBoxWidth: this.form.bridgeBoxWidth,
          bridgeBoxDeep: this.form.bridgeBoxDeep,
          bridgeBoxHigth: this.form.bridgeBoxHigth,
          pressure: this.form.pressure,
          speed: this.form.speed,
          speedUp: this.form.speedUp,
          speedDown: this.form.speedDown,
          hcNum: this.form.hcNum,
          maxPressure: this.form.maxPressure,
          upStation: this.form.upStation,
          downStation: this.form.downStation,
          baseStation: this.form.baseStation,
          hangType: this.form.hangType,
          hangNum: this.form.hangNum,
          flameProof: this.form.flameProof,
          material: this.form.material,
          materialSign: this.form.materialSign,
          testedNum: this.form.testedNum,
          bufferForm: this.form.bufferForm,
          safetyGear: this.form.safetyGear,
          drag: this.form.drag,
          brakeForm: this.form.brakeForm,
          hang: this.form.hang,
          jacking: this.form.jacking,
          openForm: this.form.openForm,
          maxWeight: this.form.maxWeight,
          nominalSpeed: this.form.nominalSpeed,
          nominalWidth: this.form.nominalWidth,
          tilt: this.form.tilt,
          conveying: this.form.conveying,
          liftingHeight: this.form.liftingHeight,
          section: this.form.section,
          controller: this.form.controller,
          driving: this.form.driving,
          computer: this.form.computer,
          assign: this.form.assign,
          storey: 0,
          stand: 0,
          door: 0,
          doorPosition: this.form.doorPosition,
          testType: this.form.testType,
          specialType: this.form.specialType,
          superviseCode: this.form.superviseCode,

          lifeArea: this.form.lifeArea,
          propertyName: this.form.propertyName,
          branchName: this.form.branchName,
          driveModel: this.form.driveModel,
          driveCode: this.form.driveCode,
          controlBoxModel: this.form.controlBoxModel,
          controlBoxCode: this.form.controlBoxCode,
          carModel: this.form.carModel,
          carCode: this.form.carCode,
          counterweightModel: this.form.counterweightModel,
          counterweightModelCode: this.form.counterweightModelCode,
          unitArea: this.form.unitArea,
          branchArea: this.form.branchArea,
          propertyArea: this.form.propertyArea,
          proof: this.form.proof,
          preDate: this.form.preDate,
          preDateType: this.form.preDateType,
          updateDateType: this.form.updateDateType,
          nextDateType: this.form.nextDateType,
          createDateType: this.form.createDateType,
          superviseDateType: this.form.superviseDateType,
          majorDateType: this.form.majorDateType,
          nextTestDateType: this.form.nextTestDateType,
          detailArea: this.form.detailArea,
        };
      }
      // console.log(new Date().getTime()+"-------1")
      this.$confirm('是否提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.count++;
        if (this.count >= 2) {
          // console.log(new Date().getTime()+"-------2")
          this.$message({
            message: "正在处理...",
            type: "warning"
          });
          return
        }
        // console.log(new Date().getTime()+"-------3")
        request.post('/Device/save', device).then(res => {
          // console.log(new Date().getTime()+"-------4")

          this.count=0;
          console.log(res.code + res.mag + res.date + "save" + res);
          if (res.code === "0" && res.data===1) {
            this.$message({
              message: "监察识别码已存在",
              type: "success"
            });
            // this.saveIs =false;
            this.load(1);
            this.dialogFormVisible = false;
          }else if (res.code === "0" && res.data===0) {
            this.$message({
              message: "添加成功",
              type: "success"
            });
            // this.saveIs =false;
            this.load(1);
            this.dialogFormVisible = false;
          }  else {
            this.$message({
              message: "添加失败",
              type: "error"
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });

    },
    //修改数据
    edit(formName) {
      // this.validator();
      if (!this.validator()) {//验证不通过
        return false;
      }
      // this.isupdate =true;
      console.log(formName);
      // this.editform.areaId = this.areaList5[this.areaParentIdFive].areaId;
      this.editform.areaId = this.areaList3[this.areaParentIdThree].areaId;
      let device = null;
      if (this.editform.specialType === 1) {
        device = {
          liftId: this.editform.liftId,
          areaId: this.editform.areaId,
          // dateType: this.editform.dateType,
          unit: this.editform.unit,
          unitCode: this.editform.unitCode,
          loginNum: this.editform.loginNum,
          unitNum: this.editform.unitNum,
          liftType: this.editform.liftType,
          liftModel: this.editform.liftModel,
          liftNum: this.editform.liftNum,
          createUnit: this.editform.createUnit,
          createDate: this.editform.createDate,
          // createDate: this.dateType(this.editform.createDateType, this.editform.createDate),
          createStandard: this.editform.createStandard,
          updateUnit: this.editform.updateUnit,
          updateDate: this.editform.updateDate,
          // updateDate: this.dateType(this.editform.updateDateType, this.editform.updateDate),
          maintenance: this.editform.maintenance,
          superviseDate: this.editform.superviseDate,
          // superviseDate: this.dateType(this.editform.superviseDateType, this.editform.superviseDate),
          superviseType: this.editform.superviseType,
          organ: this.editform.organ,
          erpNum: this.editform.erpNum,
          safety: this.editform.safety,
          safetyNum: this.editform.safetyNum,
          majorUnit: this.editform.majorUnit,
          buildUnit: this.editform.buildUnit,
          majorDate: this.editform.majorDate,
          // majorDate: this.dateType(this.editform.majorDateType, this.editform.majorDate),
          nextDate: this.editform.nextDate,
          // nextDate: this.dateType(this.editform.nextDateType, this.editform.nextDate),
          nextTestDate: this.editform.nextTestDate,
          // nextTestDate: this.dateType(this.editform.nextTestDateType, this.editform.nextTestDate),
          lifeCode: this.editform.lifeCode,
          lifeRegistCode: this.editform.lifeRegistCode,
          lifeKind: this.editform.lifeKind,
          electricModel: this.editform.electricModel,
          bridgeBoxWidth: this.editform.bridgeBoxWidth,
          bridgeBoxDeep: this.editform.bridgeBoxDeep,
          bridgeBoxHigth: this.editform.bridgeBoxHigth,
          pressure: this.editform.pressure,
          speed: this.editform.speed,
          speedUp: this.editform.speedUp,
          speedDown: this.editform.speedDown,
          hcNum: this.editform.hcNum,
          maxPressure: this.editform.maxPressure,
          upStation: this.editform.upStation,
          downStation: this.editform.downStation,
          baseStation: this.editform.baseStation,
          hangType: this.editform.hangType,
          hangNum: this.editform.hangNum,
          flameProof: this.editform.flameProof,
          material: this.editform.material,
          materialSign: this.editform.materialSign,
          testedNum: this.editform.testedNum,
          bufferForm: this.editform.bufferForm,
          safetyGear: this.editform.safetyGear,
          drag: this.editform.drag,
          brakeForm: this.editform.brakeForm,
          hang: this.editform.hang,
          jacking: this.editform.jacking,
          openForm: this.editform.openForm,
          maxWeight: this.editform.maxWeight,
          nominalSpeed: this.editform.nominalSpeed,
          nominalWidth: this.editform.nominalWidth,
          tilt: this.editform.tilt,
          conveying: this.editform.conveying,
          liftingHeight: this.editform.liftingHeight,
          section: this.editform.section,
          controller: this.editform.controller,
          driving: this.editform.driving,
          computer: this.editform.computer,
          assign: this.editform.assign,
          storey: this.editform.storey,
          stand: this.editform.stand,
          door: this.editform.door,
          doorPosition: this.editform.doorPosition,

          testType: this.editform.testType,
          specialType: this.editform.specialType,
          superviseCode: this.editform.superviseCode,
          lifeArea: this.editform.lifeArea,
          propertyName: this.editform.propertyName,
          branchName: this.editform.branchName,
          driveModel: this.editform.driveModel,
          driveCode: this.editform.driveCode,
          controlBoxModel: this.editform.controlBoxModel,
          controlBoxCode: this.editform.controlBoxCode,
          carModel: this.editform.carModel,
          carCode: this.editform.carCode,
          counterweightModel: this.editform.counterweightModel,
          counterweightModelCode: this.editform.counterweightModelCode,
          unitArea: this.editform.unitArea,
          branchArea: this.editform.branchArea,
          propertyArea: this.editform.propertyArea,
          proof: this.editform.proof,
          preDate: this.editform.preDate,
          // preDate: this.dateType(this.editform.preDateType, this.editform.preDate),
          preDateType: this.editform.preDateType,
          updateDateType: this.editform.updateDateType,
          nextDateType: this.editform.nextDateType,
          createDateType: this.editform.createDateType,
          superviseDateType: this.editform.superviseDateType,
          majorDateType: this.editform.majorDateType,
          nextTestDateType: this.editform.nextTestDateType,
          detailArea: this.editform.detailArea,
        };
      } else {
        device = {
          liftId: this.editform.liftId,
          areaId: this.editform.areaId,
          // dateType: this.editform.dateType,
          unit: this.editform.unit,
          unitCode: this.editform.unitCode,
          loginNum: this.editform.loginNum,
          unitNum: this.editform.unitNum,
          liftType: this.editform.liftType,
          liftModel: this.editform.liftModel,
          liftNum: this.editform.liftNum,
          createUnit: this.editform.createUnit,
          createDate: this.editform.createDate,
          createStandard: this.editform.createStandard,
          updateUnit: this.editform.updateUnit,
          // updateDate: this.editform.updateDate,
          maintenance: this.editform.maintenance,
          superviseDate: this.editform.superviseDate,
          superviseType: this.editform.superviseType,
          organ: this.editform.organ,
          erpNum: this.editform.erpNum,
          safety: this.editform.safety,
          safetyNum: this.editform.safetyNum,
          majorUnit: this.editform.majorUnit,
          buildUnit: this.editform.buildUnit,
          majorDate: this.editform.majorDate,
          nextDate: this.editform.nextDate,
          nextTestDate: this.editform.nextTestDate,
          lifeCode: this.editform.lifeCode,
          lifeRegistCode: this.editform.lifeRegistCode,
          lifeKind: this.editform.lifeKind,
          electricModel: this.editform.electricModel,
          bridgeBoxWidth: this.editform.bridgeBoxWidth,
          bridgeBoxDeep: this.editform.bridgeBoxDeep,
          bridgeBoxHigth: this.editform.bridgeBoxHigth,
          pressure: this.editform.pressure,
          speed: this.editform.speed,
          speedUp: this.editform.speedUp,
          speedDown: this.editform.speedDown,
          hcNum: this.editform.hcNum,
          maxPressure: this.editform.maxPressure,
          upStation: this.editform.upStation,
          downStation: this.editform.downStation,
          baseStation: this.editform.baseStation,
          hangType: this.editform.hangType,
          hangNum: this.editform.hangNum,
          flameProof: this.editform.flameProof,
          material: this.editform.material,
          materialSign: this.editform.materialSign,
          testedNum: this.editform.testedNum,
          bufferForm: this.editform.bufferForm,
          safetyGear: this.editform.safetyGear,
          drag: this.editform.drag,
          brakeForm: this.editform.brakeForm,
          hang: this.editform.hang,
          jacking: this.editform.jacking,
          openForm: this.editform.openForm,
          maxWeight: this.editform.maxWeight,
          nominalSpeed: this.editform.nominalSpeed,
          nominalWidth: this.editform.nominalWidth,
          tilt: this.editform.tilt,
          conveying: this.editform.conveying,
          liftingHeight: this.editform.liftingHeight,
          section: this.editform.section,
          controller: this.editform.controller,
          driving: this.editform.driving,
          computer: this.editform.computer,
          assign: this.editform.assign,
          storey: this.editform.storey,
          stand: this.editform.stand,
          door: this.editform.door,
          doorPosition: this.editform.doorPosition,
          testType: this.editform.testType,
          specialType: this.editform.specialType,
          superviseCode: this.editform.superviseCode,

          lifeArea: this.editform.lifeArea,
          propertyName: this.editform.propertyName,
          branchName: this.editform.branchName,
          driveModel: this.editform.driveModel,
          driveCode: this.editform.driveCode,
          controlBoxModel: this.editform.controlBoxModel,
          controlBoxCode: this.editform.controlBoxCode,
          carModel: this.editform.carModel,
          carCode: this.editform.carCode,
          counterweightModel: this.editform.counterweightModel,
          counterweightModelCode: this.editform.counterweightModelCode,
          unitArea: this.editform.unitArea,
          branchArea: this.editform.branchArea,
          propertyArea: this.editform.propertyArea,
          proof: this.editform.proof,
          preDate: this.editform.preDate,
          // createDate: this.dateType(this.editform.createDateType, this.editform.createDate),
          // updateDate: this.dateType(this.editform.updateDateType, this.editform.updateDate),
          // superviseDate: this.dateType(this.editform.superviseDateType, this.editform.superviseDate),
          // majorDate: this.dateType(this.editform.majorDateType, this.editform.majorDate),
          // nextDate: this.dateType(this.editform.nextDateType, this.editform.nextDate),
          // nextTestDate: this.dateType(this.editform.nextTestDateType, this.editform.nextTestDate),
          // preDate: this.dateType(this.editform.preDateType, this.editform.preDate),
          preDateType: this.editform.preDateType,
          updateDateType: this.editform.updateDateType,
          nextDateType: this.editform.nextDateType,
          createDateType: this.editform.createDateType,
          superviseDateType: this.editform.superviseDateType,
          majorDateType: this.editform.majorDateType,
          nextTestDateType: this.editform.nextTestDateType,
          detailArea: this.editform.detailArea,
        };
      }
      this.$confirm('是否提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // console.log(device)
        this.count++;
        if (this.count >= 2) {
          this.$message({
            message: "正在处理...",
            type: "warning"
          });
          return
        }
        request.post('/Device/update', device).then(res => {
          this.count=0;
          if (res.code === "0") {
            this.$message({
              message: "编辑成功",
              type: "success"
            });
            this.load(1);
            this.dialogFormVisibleEdit = false;
          } else {
            this.$message({
              message: "编辑失败",
              type: "error"
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });

    },

    //修改按钮点击事件
    update(row) {
      this.dialogFormVisibleEdit = true;
      this.editform = JSON.parse(JSON.stringify(row));
      // this.editform.createDate=this.dateShow(this.editform.createDateType, this.editform.createDate);
      // this.editform.updateDate=this.dateShow(this.editform.updateDateType, this.editform.updateDate);
      // this.editform.superviseDate=this.dateShow(this.editform.superviseDateType, this.editform.superviseDate);
      // this.editform.majorDate=this.dateShow(this.editform.majorDateType, this.editform.majorDate);
      // this.editform.nextDate=this.dateShow(this.editform.nextDateType, this.editform.nextDate);
      // this.editform.nextTestDate=this.dateShow(this.editform.nextTestDateType, this.editform.nextTestDate);
      // this.editform.preDate=this.dateShow(this.editform.preDateType, this.editform.preDate);
      this.getEqpType(this.editform.specialType);
      this.getliftType(this.editform.lifeKind, 1);
      // this.repeatName = row.templateName;
      console.log(this.editform + "---" + this.editform.areaId);
      request.post('/Device/ParentArea', this.editform.areaId).then(res => {
        console.log(res.data);

        this.areaList = res.data.deviceAreas1;
        for (let i = 0; i < this.areaList.length; i++) {
          if (this.areaList[i].areaId === res.data.areaId1) {
            this.areaParentIdOne = i;
          }
        }
        this.areaList2 = res.data.deviceAreas2;
        for (let i = 0; i < this.areaList2.length; i++) {
          if (this.areaList2[i].areaId === res.data.areaId2) {
            this.areaParentIdTwo = i;
          }
        }
        this.areaList3 = res.data.deviceAreas3;
        for (let i = 0; i < this.areaList3.length; i++) {
          if (this.areaList3[i].areaId === res.data.areaId3) {
            this.areaParentIdThree = i;
          }
          // if (this.areaList3[i].areaId === res.data.areaId3) {
          //   this.areaParentIdThree = i;
          // }
        }
        // this.areaList4 = res.data.deviceAreas4;
        // for (let i = 0; i < this.areaList4.length; i++) {
        //   if (this.areaList4[i].areaId === res.data.areaId4) {
        //     this.areaParentIdFour = i;
        //   }
        // }
        // this.areaList5 = res.data.deviceAreas5;
        // for (let i = 0; i < this.areaList5.length; i++) {
        //   if (this.areaList5[i].areaId === this.editform.areaId) {
        //     this.areaParentIdFive = i;
        //   }
        // }
      })
    },
    //删除按钮点击事件
    deleteOne(liftId) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.post('/Device/delete', liftId).then(res => {
          if (res.code === "0") {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          } else {
            this.$message({
              type: 'info',
              message: '已创建工单不能删除！'
            });
          }
          this.load(1);
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    queryAreaList(parentId) {
      request.post('/Device/selectArea', parentId).then(res => {
        console.log(res.data);
        this.areaList = res.data;
        this.areaList2 = [];
        this.areaList3 = [];
        // this.areaList4 = [];
        // this.areaList5 = [];
        this.areaParentIdTwo = '';
        this.areaParentIdThree = '';
        // this.areaParentIdFour = '';
        // this.areaParentIdFive = '';
      })
    },
    queryAreaList2() {
      if (this.areaParentIdOne === '') {
        this.$message({
          message: "请完成第一个选择",
          type: "warning"
        });
        this.areaParentIdTwo = '';
        this.areaList2 = [];
        this.areaParentIdThree = '';
        this.areaList3 = [];
        // this.areaParentIdFour = '';
        // this.areaList4 = [];
      } else {
        request.post('/Device/selectArea', this.areaList[this.areaParentIdOne].areaId).then(res => {
          console.log(res);
          if (res.code === "0") {
            this.areaList2 = res.data;
          } else this.areaList2 = [];
          this.areaParentIdTwo = '';
          this.areaList3 = [];
          this.areaParentIdThree = '';
          // this.areaParentIdFour = '';
          // this.areaList4 = [];
        });
      }
      // this.queryAreaList(this.areaList[this.areaParentIdOne].areaId);
    },
    queryAreaList3() {
      // console.log(this.areaParentIdTwo+"---areaId");
      if (this.areaParentIdTwo === '') {
        this.$message({
          message: "请完成第二个选择",
          type: "warning"
        });
        this.areaParentIdThree = '';
        this.areaList3 = [];
      } else {
        request.post('/Device/selectArea', this.areaList2[this.areaParentIdTwo].areaId).then(res => {
          console.log(res);
          if (res.code === "0") {
            this.areaList3 = res.data;
          } else this.areaList3 = [];
          this.areaParentIdThree = '';
          // this.areaParentIdFour = '';
          // this.areaList4 = [];
        });
      }
    },
    // queryAreaList4() {
    //   // console.log(this.areaParentIdTwo+"---areaId");
    //   if (this.areaParentIdThree === '') {
    //     this.$message({
    //       message: "请完成第三个选择",
    //       type: "warning"
    //     });
    //     this.areaParentIdFour = '';
    //     this.areaList4 = [];
    //   } else {
    //     request.post('/Device/selectArea', this.areaList3[this.areaParentIdThree].areaId).then(res => {
    //       console.log(res);
    //       if (res.code === "0") {
    //         this.areaList4 = res.data;
    //       } else this.areaList4 = [];
    //       this.areaParentIdFour = '';
    //     });
    //   }
    // },
    // queryAreaList5() {
    //   console.log(this.areaParentIdFour + "---areaId");
    //   if (this.areaParentIdFour === '') {
    //     this.$message({
    //       message: "请完成第四个选择",
    //       type: "warning"
    //     });
    //     this.areaParentIdFive = '';
    //     this.areaList5 = [];
    //   } else {
    //     request.post('/Device/selectArea', this.areaList4[this.areaParentIdFour].areaId).then(res => {
    //       console.log(res);
    //       if (res.code === "0") {
    //         this.areaList5 = res.data;
    //       } else this.areaList5 = [];
    //       this.areaParentIdFive = '';
    //     });
    //   }
    // },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      if (this.varValue !== this.search) {
        this.search = this.varValue
      }
      if (this.varValue1 !== this.superviseCode) {
        this.superviseCode = this.varValue1
      }
      this.load(1);
    },
    handleCurrentChange(pageNum) {
      this.currentPage = pageNum;
      if (this.varValue !== this.search) {
        this.search = this.varValue
      }
      if (this.varValue1 !== this.superviseCode) {
        this.superviseCode = this.varValue1
      }
      this.load(1);
    },
    tableRowClassName({rowIndex}) {
      for (var i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].solution_Lock === "锁定") {
          if (rowIndex === i) {
            return 'warning-row';
          }
        } else {
          if (rowIndex === i) {
            return 'success-row';
          }
        }
      }
      return '';
    }
  }
}
</script>

<style>

.el-table .warning-row {
  /*--el-table-tr-bg-color: var(--el-color-warning-light-9);*/
  --el-table-tr-bg-color: #e0e0eb
}

.el-table .success-row {
  --el-table-tr-bg-color: var(--el-color-success-light-9);
}

.rightStyle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 440px
}
</style>